import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/greek.js
t.dynamicSetup("", "greek", e({
	GK: { normal: {
		880: [
			.683,
			0,
			.568
		],
		881: [
			.512,
			0,
			.452
		],
		882: [
			.677,
			0,
			.722
		],
		883: [
			.507,
			0,
			.5
		],
		884: [
			.7,
			-.48,
			.194
		],
		885: [
			.004,
			.216,
			.194
		],
		886: [
			.683,
			0,
			.75
		],
		887: [
			.512,
			0,
			.528
		],
		890: [
			-.065,
			.227,
			.111
		],
		891: [
			.528,
			.014,
			.591
		],
		892: [
			.528,
			.014,
			.591
		],
		893: [
			.528,
			.014,
			.591
		],
		894: [
			.43,
			.194,
			.278
		],
		895: [
			.683,
			.022,
			.514
		],
		900: [
			.7,
			-.479,
			.167
		],
		901: [
			.7,
			-.479,
			.278
		],
		902: [
			.716,
			0,
			.75
		],
		903: [
			.43,
			-.323,
			.278
		],
		904: [
			.7,
			0,
			.874
		],
		905: [
			.7,
			0,
			.944
		],
		906: [
			.7,
			0,
			.559
		],
		908: [
			.705,
			.022,
			.852
		],
		910: [
			.715,
			0,
			.93
		],
		911: [
			.705,
			0,
			.836
		],
		912: [
			.704,
			.013,
			.25
		],
		938: [
			.831,
			0,
			.361
		],
		939: [
			.831,
			0,
			.778
		],
		940: [
			.7,
			.011,
			.5
		],
		941: [
			.7,
			.022,
			.43
		],
		942: [
			.7,
			.271,
			.5
		],
		943: [
			.7,
			.013,
			.25
		],
		944: [
			.704,
			.01,
			.5
		],
		970: [
			.613,
			.013,
			.25
		],
		971: [
			.613,
			.01,
			.5
		],
		972: [
			.7,
			.011,
			.528
		],
		973: [
			.7,
			.01,
			.5
		],
		974: [
			.7,
			.01,
			.667
		],
		975: [
			.683,
			.262,
			.764
		],
		976: [
			.705,
			.011,
			.522
		],
		979: [
			.715,
			0,
			.778
		],
		980: [
			.831,
			0,
			.778
		],
		983: [
			.456,
			.261,
			.528
		],
		984: [
			.694,
			.002,
			.5
		],
		985: [
			.598,
			.064,
			.5
		],
		986: [
			.678,
			0,
			.778
		],
		987: [
			.453,
			.034,
			.5
		],
		988: [
			.68,
			0,
			.625
		],
		989: [
			.429,
			.259,
			.5
		],
		990: [
			.68,
			.006,
			.389
		],
		991: [
			.608,
			.139,
			.389
		],
		992: [
			.694,
			0,
			.766
		],
		993: [
			.694,
			.021,
			.722
		],
		994: [
			.705,
			.219,
			.982
		],
		995: [
			.433,
			.216,
			.789
		],
		996: [
			.686,
			.19,
			.658
		],
		997: [
			.444,
			.279,
			.535
		],
		998: [
			.683,
			.205,
			.698
		],
		999: [
			.459,
			.205,
			.555
		],
		1e3: [
			.666,
			.134,
			.51
		],
		1001: [
			.466,
			.134,
			.484
		],
		1002: [
			.705,
			0,
			.75
		],
		1003: [
			.433,
			0,
			.528
		],
		1004: [
			.684,
			.011,
			.5
		],
		1005: [
			.465,
			.009,
			.5
		],
		1006: [
			.683,
			0,
			.716
		],
		1007: [
			.654,
			0,
			.458
		],
		1010: [
			.448,
			.011,
			.444
		],
		1011: [
			.657,
			.211,
			.266
		],
		1015: [
			.683,
			0,
			.625
		],
		1016: [
			.728,
			.28,
			.472
		],
		1017: [
			.705,
			.022,
			.722
		],
		1018: [
			.683,
			0,
			.916
		],
		1019: [
			.43,
			.166,
			.583,
			{ ic: .083 }
		],
		1020: [
			.446,
			.26,
			.472
		],
		1021: [
			.705,
			.022,
			.722
		],
		1022: [
			.705,
			.022,
			.722
		],
		1023: [
			.705,
			.022,
			.722
		],
		7936: [
			.694,
			.011,
			.5
		],
		7937: [
			.694,
			.011,
			.5
		],
		7938: [
			.699,
			.011,
			.5
		],
		7939: [
			.699,
			.011,
			.5
		],
		7940: [
			.699,
			.011,
			.5
		],
		7941: [
			.699,
			.011,
			.5
		],
		7942: [
			.694,
			.011,
			.5
		],
		7943: [
			.694,
			.011,
			.5
		],
		7944: [
			.716,
			0,
			.803
		],
		7945: [
			.716,
			0,
			.765
		],
		7946: [
			.716,
			0,
			.905
		],
		7947: [
			.716,
			0,
			.905
		],
		7948: [
			.716,
			0,
			.845
		],
		7949: [
			.716,
			0,
			.845
		],
		7950: [
			.716,
			0,
			.872
		],
		7951: [
			.716,
			0,
			.872
		],
		7952: [
			.694,
			.022,
			.43
		],
		7953: [
			.694,
			.022,
			.43
		],
		7954: [
			.699,
			.022,
			.43
		],
		7955: [
			.699,
			.022,
			.43
		],
		7956: [
			.699,
			.022,
			.43
		],
		7957: [
			.699,
			.022,
			.43
		],
		7960: [
			.694,
			0,
			.902
		],
		7961: [
			.694,
			0,
			.902
		],
		7962: [
			.699,
			0,
			.958
		],
		7963: [
			.699,
			0,
			.958
		],
		7964: [
			.699,
			0,
			.958
		],
		7965: [
			.699,
			0,
			.958
		],
		7968: [
			.694,
			.272,
			.5
		],
		7969: [
			.694,
			.272,
			.5
		],
		7970: [
			.7,
			.272,
			.5
		],
		7971: [
			.7,
			.272,
			.5
		],
		7972: [
			.7,
			.272,
			.5
		],
		7973: [
			.7,
			.272,
			.5
		],
		7974: [
			.694,
			.271,
			.5
		],
		7975: [
			.694,
			.272,
			.5
		],
		7976: [
			.694,
			0,
			.972
		],
		7977: [
			.694,
			0,
			.972
		],
		7978: [
			.699,
			0,
			1.028
		],
		7979: [
			.699,
			0,
			1.028
		],
		7980: [
			.699,
			0,
			1.028
		],
		7981: [
			.699,
			0,
			1.028
		],
		7982: [
			.694,
			0,
			1.083
		],
		7983: [
			.694,
			0,
			1.083
		],
		7984: [
			.694,
			.013,
			.25
		],
		7985: [
			.694,
			.013,
			.25
		],
		7986: [
			.699,
			.013,
			.25
		],
		7987: [
			.699,
			.013,
			.25
		],
		7988: [
			.699,
			.013,
			.25
		],
		7989: [
			.699,
			.013,
			.25
		],
		7990: [
			.694,
			.013,
			.25,
			{ ic: .009 }
		],
		7991: [
			.694,
			.013,
			.25,
			{ ic: .009 }
		],
		7992: [
			.694,
			0,
			.583
		],
		7993: [
			.694,
			0,
			.583
		],
		7994: [
			.699,
			0,
			.639
		],
		7995: [
			.699,
			0,
			.639
		],
		7996: [
			.699,
			0,
			.639
		],
		7997: [
			.699,
			0,
			.639
		],
		7998: [
			.694,
			0,
			.694
		],
		7999: [
			.694,
			0,
			.694
		],
		8e3: [
			.694,
			.011,
			.528
		],
		8001: [
			.694,
			.011,
			.528
		],
		8002: [
			.699,
			.011,
			.528
		],
		8003: [
			.699,
			.011,
			.528
		],
		8004: [
			.699,
			.011,
			.528
		],
		8005: [
			.699,
			.011,
			.528
		],
		8008: [
			.705,
			.022,
			.944
		],
		8009: [
			.705,
			.022,
			.924
		],
		8010: [
			.705,
			.022,
			1.028
		],
		8011: [
			.705,
			.022,
			1.028
		],
		8012: [
			.705,
			.022,
			1.008
		],
		8013: [
			.705,
			.022,
			1.008
		],
		8016: [
			.694,
			.011,
			.5
		],
		8017: [
			.694,
			.011,
			.5
		],
		8018: [
			.699,
			.011,
			.5
		],
		8019: [
			.699,
			.011,
			.5
		],
		8020: [
			.699,
			.011,
			.5
		],
		8021: [
			.699,
			.011,
			.5
		],
		8022: [
			.694,
			.01,
			.5
		],
		8023: [
			.694,
			.011,
			.5
		],
		8025: [
			.705,
			0,
			.98
		],
		8027: [
			.705,
			0,
			1.056
		],
		8029: [
			.705,
			0,
			1.056
		],
		8031: [
			.705,
			0,
			1.111
		],
		8032: [
			.694,
			.011,
			.667
		],
		8033: [
			.694,
			.011,
			.667
		],
		8034: [
			.7,
			.011,
			.667
		],
		8035: [
			.7,
			.011,
			.667
		],
		8036: [
			.7,
			.011,
			.667
		],
		8037: [
			.7,
			.011,
			.667
		],
		8038: [
			.694,
			.011,
			.667
		],
		8039: [
			.694,
			.011,
			.667
		],
		8040: [
			.705,
			0,
			.916
		],
		8041: [
			.705,
			0,
			.896
		],
		8042: [
			.705,
			0,
			1
		],
		8043: [
			.705,
			0,
			1
		],
		8044: [
			.705,
			0,
			.98
		],
		8045: [
			.705,
			0,
			.98
		],
		8046: [
			.705,
			0,
			1.035
		],
		8047: [
			.705,
			0,
			1.035
		],
		8048: [
			.698,
			.011,
			.5
		],
		8049: [
			.7,
			.011,
			.5
		],
		8050: [
			.699,
			.022,
			.43
		],
		8051: [
			.699,
			.022,
			.43
		],
		8052: [
			.7,
			.272,
			.5
		],
		8053: [
			.699,
			.272,
			.5
		],
		8054: [
			.699,
			.013,
			.25
		],
		8055: [
			.699,
			.013,
			.25
		],
		8056: [
			.699,
			.011,
			.528
		],
		8057: [
			.699,
			.011,
			.528
		],
		8058: [
			.699,
			.011,
			.5
		],
		8059: [
			.699,
			.011,
			.5
		],
		8060: [
			.699,
			.011,
			.667
		],
		8061: [
			.699,
			.011,
			.667
		],
		8064: [
			.694,
			.227,
			.5
		],
		8065: [
			.694,
			.227,
			.5
		],
		8066: [
			.699,
			.227,
			.5
		],
		8067: [
			.699,
			.227,
			.5
		],
		8068: [
			.699,
			.227,
			.5
		],
		8069: [
			.699,
			.227,
			.5
		],
		8070: [
			.694,
			.227,
			.5
		],
		8071: [
			.694,
			.227,
			.5
		],
		8072: [
			.716,
			.211,
			.833
		],
		8073: [
			.716,
			.211,
			.755
		],
		8074: [
			.716,
			.211,
			.895
		],
		8075: [
			.716,
			.211,
			.895
		],
		8076: [
			.716,
			.211,
			.845
		],
		8077: [
			.716,
			.211,
			.845
		],
		8078: [
			.716,
			.211,
			.892
		],
		8079: [
			.716,
			.211,
			.892
		],
		8080: [
			.694,
			.272,
			.5
		],
		8081: [
			.694,
			.272,
			.5
		],
		8082: [
			.7,
			.272,
			.5
		],
		8083: [
			.7,
			.272,
			.5
		],
		8084: [
			.7,
			.272,
			.5
		],
		8085: [
			.7,
			.272,
			.5
		],
		8086: [
			.694,
			.272,
			.5
		],
		8087: [
			.694,
			.272,
			.5
		],
		8088: [
			.694,
			.211,
			.972
		],
		8089: [
			.694,
			.211,
			.952
		],
		8090: [
			.699,
			.211,
			1.028
		],
		8091: [
			.699,
			.211,
			1.028
		],
		8092: [
			.699,
			.211,
			1.028
		],
		8093: [
			.699,
			.211,
			1.028
		],
		8094: [
			.694,
			.211,
			1.083
		],
		8095: [
			.694,
			.211,
			1.083
		],
		8096: [
			.694,
			.227,
			.667
		],
		8097: [
			.694,
			.227,
			.667
		],
		8098: [
			.7,
			.227,
			.667
		],
		8099: [
			.7,
			.227,
			.667
		],
		8100: [
			.7,
			.227,
			.667
		],
		8101: [
			.7,
			.227,
			.667
		],
		8102: [
			.694,
			.227,
			.667
		],
		8103: [
			.694,
			.227,
			.667
		],
		8104: [
			.705,
			.211,
			.916
		],
		8105: [
			.705,
			.211,
			.896
		],
		8106: [
			.705,
			.211,
			1
		],
		8107: [
			.705,
			.211,
			1
		],
		8108: [
			.705,
			.211,
			.98
		],
		8109: [
			.705,
			.211,
			.98
		],
		8110: [
			.705,
			.211,
			1.035
		],
		8111: [
			.705,
			.211,
			1.035
		],
		8112: [
			.67,
			.011,
			.5
		],
		8113: [
			.565,
			.011,
			.5
		],
		8114: [
			.698,
			.227,
			.5
		],
		8115: [
			.441,
			.227,
			.5
		],
		8116: [
			.7,
			.227,
			.5
		],
		8118: [
			.625,
			.011,
			.5
		],
		8119: [
			.625,
			.227,
			.5
		],
		8120: [
			.939,
			0,
			.75
		],
		8121: [
			.799,
			0,
			.75
		],
		8122: [
			.716,
			0,
			.806
		],
		8123: [
			.716,
			0,
			.75
		],
		8124: [
			.716,
			.211,
			.75
		],
		8125: [
			.694,
			-.496,
			.222
		],
		8126: [
			.157,
			.157,
			.222
		],
		8127: [
			.694,
			-.496,
			.222
		],
		8128: [
			.625,
			-.528,
			.333
		],
		8129: [
			.694,
			-.482,
			.444
		],
		8130: [
			.7,
			.272,
			.5
		],
		8131: [
			.453,
			.272,
			.5
		],
		8132: [
			.699,
			.272,
			.5
		],
		8134: [
			.625,
			.272,
			.5
		],
		8135: [
			.625,
			.272,
			.5
		],
		8136: [
			.699,
			0,
			.847
		],
		8137: [
			.699,
			0,
			.874
		],
		8138: [
			.699,
			0,
			.917
		],
		8139: [
			.699,
			0,
			.944
		],
		8140: [
			.683,
			.211,
			.75
		],
		8141: [
			.699,
			-.48,
			.278,
			{ ic: .017 }
		],
		8142: [
			.699,
			-.48,
			.278,
			{ ic: .012 }
		],
		8143: [
			.694,
			-.474,
			.333
		],
		8144: [
			.67,
			.013,
			.25,
			{ ic: .034 }
		],
		8145: [
			.53,
			.013,
			.25,
			{ ic: .034 }
		],
		8146: [
			.699,
			.013,
			.25
		],
		8147: [
			.699,
			.013,
			.25
		],
		8150: [
			.625,
			.013,
			.25,
			{ ic: .009 }
		],
		8151: [
			.694,
			.013,
			.25,
			{ ic: .009 }
		],
		8152: [
			.928,
			0,
			.361,
			{ ic: .013 }
		],
		8153: [
			.788,
			0,
			.361,
			{ ic: .013 }
		],
		8154: [
			.699,
			0,
			.528
		],
		8155: [
			.699,
			0,
			.559
		],
		8157: [
			.699,
			-.48,
			.278,
			{ ic: .017 }
		],
		8158: [
			.699,
			-.48,
			.278,
			{ ic: .012 }
		],
		8159: [
			.694,
			-.474,
			.333
		],
		8160: [
			.679,
			.011,
			.5
		],
		8161: [
			.539,
			.011,
			.5
		],
		8162: [
			.699,
			.011,
			.5
		],
		8163: [
			.699,
			.011,
			.5
		],
		8164: [
			.694,
			.26,
			.472
		],
		8165: [
			.694,
			.26,
			.472
		],
		8166: [
			.625,
			.011,
			.5
		],
		8167: [
			.694,
			.011,
			.5
		],
		8168: [
			.928,
			0,
			.778
		],
		8169: [
			.788,
			0,
			.778
		],
		8170: [
			.705,
			0,
			.945
		],
		8171: [
			.705,
			0,
			.93
		],
		8172: [
			.694,
			0,
			.882
		],
		8173: [
			.699,
			-.48,
			.278
		],
		8174: [
			.699,
			-.48,
			.278
		],
		8175: [
			.699,
			-.48,
			.167
		],
		8178: [
			.699,
			.227,
			.667
		],
		8179: [
			.45,
			.227,
			.667
		],
		8180: [
			.699,
			.227,
			.667
		],
		8182: [
			.625,
			.011,
			.667
		],
		8183: [
			.625,
			.227,
			.667
		],
		8184: [
			.705,
			.022,
			.889
		],
		8185: [
			.705,
			.022,
			.852
		],
		8186: [
			.705,
			0,
			.861
		],
		8187: [
			.705,
			0,
			.876
		],
		8188: [
			.705,
			.211,
			.722
		],
		8189: [
			.7,
			-.479,
			.172
		],
		8190: [
			.694,
			-.496,
			.222
		],
		11392: [
			.672,
			.007,
			.75
		],
		11393: [
			.432,
			.01,
			.566
		],
		11394: [
			.683,
			.001,
			.708
		],
		11395: [
			.43,
			0,
			.5
		],
		11396: [
			.68,
			0,
			.625
		],
		11397: [
			.43,
			0,
			.472
		],
		11398: [
			.672,
			0,
			.75
		],
		11399: [
			.432,
			0,
			.576
		],
		11400: [
			.705,
			.022,
			.681
		],
		11401: [
			.447,
			.011,
			.438
		],
		11402: [
			.716,
			.1,
			.813
		],
		11403: [
			.477,
			.151,
			.625
		],
		11404: [
			.683,
			.085,
			.605
		],
		11405: [
			.43,
			.062,
			.419
		],
		11406: [
			.683,
			0,
			.75
		],
		11407: [
			.43,
			0,
			.555
		],
		11408: [
			.705,
			.022,
			.778
		],
		11409: [
			.447,
			.011,
			.5
		],
		11410: [
			.683,
			0,
			.361
		],
		11411: [
			.43,
			0,
			.25
		],
		11412: [
			.683,
			0,
			.778
		],
		11413: [
			.43,
			0,
			.555
		],
		11414: [
			.684,
			0,
			.694
		],
		11415: [
			.43,
			0,
			.475
		],
		11416: [
			.683,
			.012,
			1.127
		],
		11417: [
			.43,
			.008,
			.749
		],
		11418: [
			.683,
			0,
			.75
		],
		11419: [
			.432,
			0,
			.552
		],
		11420: [
			.677,
			.097,
			.637
		],
		11421: [
			.431,
			.074,
			.402
		],
		11422: [
			.705,
			.022,
			.778
		],
		11423: [
			.448,
			.011,
			.5
		],
		11424: [
			.68,
			0,
			.75
		],
		11425: [
			.43,
			0,
			.555
		],
		11426: [
			.686,
			0,
			.68
		],
		11427: [
			.43,
			0,
			.5
		],
		11428: [
			.705,
			.022,
			.722
		],
		11429: [
			.447,
			.011,
			.439
		],
		11430: [
			.677,
			0,
			.722
		],
		11431: [
			.43,
			0,
			.5
		],
		11432: [
			.683,
			0,
			.75
		],
		11433: [
			.431,
			0,
			.547
		],
		11434: [
			.683,
			0,
			.722
		],
		11435: [
			.43,
			.088,
			.458
		],
		11436: [
			.683,
			0,
			.75
		],
		11437: [
			.43,
			0,
			.528
		],
		11438: [
			.683,
			0,
			.778
		],
		11439: [
			.43,
			0,
			.583
		],
		11440: [
			.705,
			.022,
			1
		],
		11441: [
			.433,
			.011,
			.779
		],
		11442: [
			.678,
			-.129,
			.728
		],
		11443: [
			.43,
			-.061,
			.499
		],
		11444: [
			.695,
			0,
			.49
		],
		11445: [
			.439,
			0,
			.313
		],
		11446: [
			.763,
			.086,
			.667
		],
		11447: [
			.498,
			.069,
			.533
		],
		11448: [
			.695,
			.15,
			.524
		],
		11449: [
			.439,
			.108,
			.337
		],
		11450: [
			.473,
			-.23,
			.667
		],
		11451: [
			.321,
			-.123,
			.533
		],
		11452: [
			.685,
			.008,
			.667,
			{ ic: .043 }
		],
		11453: [
			.434,
			.005,
			.61
		],
		11454: [
			.685,
			.008,
			.843
		],
		11455: [
			.434,
			.005,
			.734
		],
		11456: [
			.686,
			0,
			.74
		],
		11457: [
			.43,
			.142,
			.5
		],
		11458: [
			1.063,
			.219,
			.982
		],
		11459: [
			.79,
			.216,
			.789
		],
		11460: [
			.683,
			.022,
			.555
		],
		11461: [
			.43,
			.205,
			.444
		],
		11462: [
			.683,
			.167,
			.409
		],
		11463: [
			.43,
			.122,
			.25
		],
		11464: [
			.666,
			.134,
			.536
		],
		11465: [
			.466,
			.134,
			.513
		],
		11466: [
			.694,
			.109,
			.488
		],
		11467: [
			.43,
			.078,
			.355
		],
		11468: [
			.666,
			.022,
			.48
		],
		11469: [
			.472,
			.126,
			.43
		],
		11470: [
			.686,
			.169,
			.63
		],
		11471: [
			.43,
			.122,
			.414
		],
		11472: [
			.683,
			0,
			.625
		],
		11473: [
			.43,
			0,
			.472
		],
		11474: [
			.669,
			.022,
			.488
		],
		11475: [
			.498,
			.01,
			.355
		],
		11476: [
			.873,
			0,
			.401
		],
		11477: [
			.608,
			0,
			.343
		],
		11478: [
			.683,
			.196,
			.687
		],
		11479: [
			.43,
			.158,
			.522
		],
		11480: [
			.68,
			0,
			.75
		],
		11481: [
			.43,
			0,
			.555
		],
		11482: [
			.672,
			0,
			.75
		],
		11483: [
			.432,
			-0,
			.576
		],
		11484: [
			.899,
			.022,
			.778
		],
		11485: [
			.635,
			.011,
			.5
		],
		11486: [
			.68,
			.001,
			.625
		],
		11487: [
			.43,
			-0,
			.472
		],
		11488: [
			.681,
			.402,
			.817
		],
		11489: [
			.454,
			.268,
			.623
		],
		11490: [
			.677,
			.221,
			.742
		],
		11491: [
			.43,
			.165,
			.5
		],
		11492: [
			.43,
			.252,
			.567,
			{ ic: .005 }
		],
		11493: [
			.708,
			.162,
			.749
		],
		11494: [
			.708,
			.162,
			.648
		],
		11495: [
			.808,
			.162,
			1.143
		],
		11496: [
			.708,
			.162,
			.749
		],
		11497: [
			.708,
			.162,
			.616
		],
		11498: [
			.448,
			.011,
			.918
		],
		11499: [
			.69,
			-.06,
			.789
		],
		11500: [
			.477,
			-.023,
			.533
		],
		11501: [
			.685,
			.008,
			.667,
			{ ic: .043 }
		],
		11502: [
			.434,
			.005,
			.61
		],
		11503: [
			.697,
			-.499,
			.533
		],
		11504: [
			.782,
			-.614,
			0,
			{ dx: .277 }
		],
		11505: [
			.782,
			-.614,
			0,
			{ dx: .233 }
		],
		11506: [
			.76,
			.022,
			.778
		],
		11507: [
			.503,
			.014,
			.5
		],
		11513: [
			.562,
			0,
			.843
		],
		11514: [
			.562,
			.009,
			.573
		],
		11515: [
			.562,
			.009,
			.573
		],
		11516: [
			.562,
			0,
			.843
		],
		11517: [
			.439,
			.004,
			.241
		],
		11518: [
			.42,
			.011,
			.313
		],
		11519: [
			.572,
			-.37,
			.313
		]
	} },
	GKB: { bold: {
		880: [
			.686,
			0,
			.654
		],
		881: [
			.516,
			0,
			.55
		],
		882: [
			.675,
			0,
			.8
		],
		883: [
			.505,
			0,
			.638
		],
		884: [
			.711,
			-.489,
			.261
		],
		885: [
			.005,
			.217,
			.261
		],
		886: [
			.686,
			0,
			.9
		],
		887: [
			.516,
			0,
			.733
		],
		890: [
			-.055,
			.243,
			.161
		],
		891: [
			.523,
			.007,
			.669
		],
		892: [
			.523,
			.007,
			.669
		],
		893: [
			.523,
			.007,
			.669
		],
		894: [
			.445,
			.193,
			.361
		],
		895: [
			.686,
			.011,
			.594
		],
		900: [
			.711,
			-.489,
			.228
		],
		901: [
			.711,
			-.489,
			.628
		],
		902: [
			.711,
			0,
			.933
		],
		903: [
			.445,
			-.289,
			.361
		],
		904: [
			.711,
			0,
			1.044
		],
		905: [
			.711,
			0,
			1.192
		],
		906: [
			.711,
			0,
			.703
		],
		908: [
			.711,
			.011,
			1.044
		],
		910: [
			.711,
			0,
			1.189
		],
		911: [
			.711,
			0,
			1.008
		],
		912: [
			.711,
			.009,
			.328,
			{ ic: .078 }
		],
		938: [
			.886,
			0,
			.475
		],
		939: [
			.886,
			0,
			.961
		],
		940: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		941: [
			.711,
			.011,
			.544
		],
		942: [
			.711,
			.261,
			.628
		],
		943: [
			.711,
			.009,
			.328
		],
		944: [
			.711,
			.005,
			.628
		],
		970: [
			.694,
			.009,
			.328,
			{ ic: .03 }
		],
		971: [
			.694,
			.005,
			.628
		],
		972: [
			.711,
			.005,
			.661
		],
		973: [
			.711,
			.005,
			.628
		],
		974: [
			.711,
			.005,
			.828
		],
		975: [
			.686,
			.258,
			.901
		],
		976: [
			.705,
			.011,
			.532
		],
		979: [
			.702,
			0,
			1.032
		],
		980: [
			.886,
			0,
			.778,
			{ ic: .041 }
		],
		983: [
			.479,
			.261,
			.528
		],
		984: [
			.691,
			.004,
			.628
		],
		985: [
			.648,
			.099,
			.628
		],
		986: [
			.675,
			0,
			.961
		],
		987: [
			.455,
			.026,
			.628
		],
		990: [
			.695,
			.024,
			.389
		],
		991: [
			.618,
			.146,
			.494
		],
		992: [
			.702,
			0,
			.948
		],
		993: [
			.694,
			.01,
			.894
		],
		994: [
			.707,
			.219,
			.982
		],
		995: [
			.434,
			.216,
			.789
		],
		996: [
			.689,
			.19,
			.738
		],
		997: [
			.451,
			.281,
			.535
		],
		998: [
			.686,
			.205,
			.731
		],
		999: [
			.46,
			.205,
			.555
		],
		1e3: [
			.666,
			.134,
			.51
		],
		1001: [
			.466,
			.134,
			.484
		],
		1002: [
			.705,
			0,
			.75
		],
		1003: [
			.433,
			.001,
			.528
		],
		1004: [
			.684,
			.011,
			.5
		],
		1005: [
			.465,
			.037,
			.5
		],
		1006: [
			.683,
			0,
			.716
		],
		1007: [
			.656,
			.001,
			.458
		],
		1010: [
			.453,
			.006,
			.498
		],
		1011: [
			.685,
			.2,
			.388
		],
		1015: [
			.683,
			0,
			.625
		],
		1016: [
			.738,
			.295,
			.472
		],
		1017: [
			.697,
			.011,
			.831
		],
		1018: [
			.683,
			0,
			.916
		],
		1019: [
			.43,
			.181,
			.657
		],
		1020: [
			.45,
			.256,
			.622
		],
		1021: [
			.697,
			.011,
			.831
		],
		1022: [
			.697,
			.011,
			.831
		],
		1023: [
			.697,
			.011,
			.831
		],
		7936: [
			.694,
			.005,
			.655,
			{ ic: .011 }
		],
		7937: [
			.694,
			.005,
			.655,
			{ ic: .011 }
		],
		7938: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		7939: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		7940: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		7941: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		7942: [
			.694,
			.005,
			.628,
			{ ic: .038 }
		],
		7943: [
			.694,
			.005,
			.655,
			{ ic: .011 }
		],
		7944: [
			.698,
			0,
			.96
		],
		7945: [
			.698,
			0,
			.937
		],
		7946: [
			.711,
			0,
			1.054
		],
		7947: [
			.711,
			0,
			1.064
		],
		7948: [
			.711,
			0,
			1.034
		],
		7949: [
			.711,
			0,
			1.034
		],
		7950: [
			.698,
			0,
			1.098
		],
		7951: [
			.698,
			0,
			1.078
		],
		7952: [
			.694,
			.011,
			.544
		],
		7953: [
			.694,
			.011,
			.544
		],
		7954: [
			.711,
			.011,
			.544
		],
		7955: [
			.711,
			.011,
			.544
		],
		7956: [
			.711,
			.011,
			.544
		],
		7957: [
			.711,
			.011,
			.544
		],
		7960: [
			.694,
			0,
			1.11
		],
		7961: [
			.694,
			0,
			1.11
		],
		7962: [
			.711,
			0,
			1.177
		],
		7963: [
			.711,
			0,
			1.177
		],
		7964: [
			.711,
			0,
			1.177
		],
		7965: [
			.711,
			0,
			1.177
		],
		7968: [
			.694,
			.261,
			.628
		],
		7969: [
			.694,
			.261,
			.628
		],
		7970: [
			.711,
			.261,
			.628
		],
		7971: [
			.711,
			.261,
			.628
		],
		7972: [
			.711,
			.261,
			.628
		],
		7973: [
			.711,
			.261,
			.628
		],
		7974: [
			.694,
			.261,
			.628
		],
		7975: [
			.694,
			.261,
			.628
		],
		7976: [
			.694,
			0,
			1.258
		],
		7977: [
			.694,
			0,
			1.258
		],
		7978: [
			.711,
			0,
			1.325
		],
		7979: [
			.711,
			0,
			1.325
		],
		7980: [
			.711,
			0,
			1.325
		],
		7981: [
			.711,
			0,
			1.325
		],
		7982: [
			.694,
			0,
			1.392
		],
		7983: [
			.694,
			0,
			1.392
		],
		7984: [
			.694,
			.009,
			.328
		],
		7985: [
			.694,
			.009,
			.328
		],
		7986: [
			.711,
			.009,
			.328
		],
		7987: [
			.711,
			.009,
			.328
		],
		7988: [
			.711,
			.009,
			.328
		],
		7989: [
			.711,
			.009,
			.328
		],
		7990: [
			.694,
			.009,
			.328,
			{ ic: .014 }
		],
		7991: [
			.694,
			.009,
			.328,
			{ ic: .014 }
		],
		7992: [
			.694,
			0,
			.769
		],
		7993: [
			.694,
			0,
			.769
		],
		7994: [
			.711,
			0,
			.836
		],
		7995: [
			.711,
			0,
			.836
		],
		7996: [
			.711,
			0,
			.836
		],
		7997: [
			.711,
			0,
			.836
		],
		7998: [
			.694,
			0,
			.903
		],
		7999: [
			.694,
			0,
			.903
		],
		8e3: [
			.694,
			.005,
			.661
		],
		8001: [
			.694,
			.005,
			.661
		],
		8002: [
			.711,
			.005,
			.661
		],
		8003: [
			.711,
			.005,
			.661
		],
		8004: [
			.711,
			.005,
			.661
		],
		8005: [
			.711,
			.005,
			.661
		],
		8008: [
			.697,
			.011,
			1.157
		],
		8009: [
			.697,
			.011,
			1.157
		],
		8010: [
			.711,
			.011,
			1.258
		],
		8011: [
			.711,
			.011,
			1.258
		],
		8012: [
			.711,
			.011,
			1.258
		],
		8013: [
			.711,
			.011,
			1.258
		],
		8016: [
			.694,
			.005,
			.628
		],
		8017: [
			.694,
			.005,
			.628
		],
		8018: [
			.711,
			.005,
			.628
		],
		8019: [
			.711,
			.005,
			.628
		],
		8020: [
			.711,
			.005,
			.628
		],
		8021: [
			.711,
			.005,
			.628
		],
		8022: [
			.694,
			.005,
			.628
		],
		8023: [
			.694,
			.005,
			.628
		],
		8025: [
			.697,
			0,
			1.215
		],
		8027: [
			.711,
			0,
			1.322
		],
		8029: [
			.711,
			0,
			1.322
		],
		8031: [
			.697,
			0,
			1.389
		],
		8032: [
			.694,
			.005,
			.828
		],
		8033: [
			.694,
			.005,
			.828
		],
		8034: [
			.711,
			.005,
			.828
		],
		8035: [
			.711,
			.005,
			.828
		],
		8036: [
			.711,
			.005,
			.828
		],
		8037: [
			.711,
			.005,
			.828
		],
		8038: [
			.694,
			.005,
			.828
		],
		8039: [
			.694,
			.005,
			.828
		],
		8040: [
			.697,
			0,
			1.155
		],
		8041: [
			.697,
			0,
			1.155
		],
		8042: [
			.711,
			0,
			1.255
		],
		8043: [
			.711,
			0,
			1.255
		],
		8044: [
			.711,
			0,
			1.255
		],
		8045: [
			.711,
			0,
			1.255
		],
		8046: [
			.697,
			0,
			1.322
		],
		8047: [
			.697,
			0,
			1.322
		],
		8048: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		8049: [
			.711,
			.005,
			.655,
			{ ic: .011 }
		],
		8050: [
			.711,
			.011,
			.544
		],
		8051: [
			.711,
			.011,
			.544
		],
		8052: [
			.711,
			.261,
			.628
		],
		8053: [
			.711,
			.261,
			.628
		],
		8054: [
			.711,
			.009,
			.328
		],
		8055: [
			.711,
			.009,
			.328
		],
		8056: [
			.711,
			.005,
			.661
		],
		8057: [
			.711,
			.005,
			.661
		],
		8058: [
			.711,
			.005,
			.628
		],
		8059: [
			.711,
			.005,
			.628
		],
		8060: [
			.711,
			.005,
			.828
		],
		8061: [
			.711,
			.005,
			.828
		],
		8064: [
			.694,
			.243,
			.655,
			{ ic: .011 }
		],
		8065: [
			.694,
			.243,
			.655,
			{ ic: .011 }
		],
		8066: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8067: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8068: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8069: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8070: [
			.694,
			.243,
			.655,
			{ ic: .011 }
		],
		8071: [
			.694,
			.243,
			.655,
			{ ic: .011 }
		],
		8072: [
			.698,
			.244,
			.96
		],
		8073: [
			.698,
			.244,
			.947
		],
		8074: [
			.711,
			.244,
			1.084
		],
		8075: [
			.711,
			.244,
			1.074
		],
		8076: [
			.711,
			.244,
			1.044
		],
		8077: [
			.711,
			.244,
			1.034
		],
		8078: [
			.698,
			.244,
			1.098
		],
		8079: [
			.698,
			.244,
			1.088
		],
		8080: [
			.694,
			.261,
			.628
		],
		8081: [
			.694,
			.261,
			.628
		],
		8082: [
			.711,
			.261,
			.628
		],
		8083: [
			.711,
			.261,
			.628
		],
		8084: [
			.711,
			.261,
			.628
		],
		8085: [
			.711,
			.261,
			.628
		],
		8086: [
			.694,
			.261,
			.628
		],
		8087: [
			.694,
			.261,
			.628
		],
		8088: [
			.694,
			.244,
			1.258
		],
		8089: [
			.694,
			.244,
			1.258
		],
		8090: [
			.711,
			.244,
			1.325
		],
		8091: [
			.711,
			.244,
			1.325
		],
		8092: [
			.711,
			.244,
			1.325
		],
		8093: [
			.711,
			.244,
			1.325
		],
		8094: [
			.694,
			.244,
			1.392
		],
		8095: [
			.694,
			.244,
			1.392
		],
		8096: [
			.694,
			.243,
			.828
		],
		8097: [
			.694,
			.243,
			.828
		],
		8098: [
			.711,
			.243,
			.828
		],
		8099: [
			.711,
			.243,
			.828
		],
		8100: [
			.711,
			.243,
			.828
		],
		8101: [
			.711,
			.243,
			.828
		],
		8102: [
			.694,
			.243,
			.828
		],
		8103: [
			.694,
			.243,
			.828
		],
		8104: [
			.697,
			.244,
			1.155
		],
		8105: [
			.697,
			.244,
			1.155
		],
		8106: [
			.711,
			.244,
			1.255
		],
		8107: [
			.711,
			.244,
			1.255
		],
		8108: [
			.711,
			.244,
			1.255
		],
		8109: [
			.711,
			.244,
			1.255
		],
		8110: [
			.697,
			.244,
			1.322
		],
		8111: [
			.697,
			.244,
			1.322
		],
		8112: [
			.69,
			.005,
			.655,
			{ ic: .011 }
		],
		8113: [
			.554,
			.005,
			.655,
			{ ic: .011 }
		],
		8114: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8115: [
			.45,
			.243,
			.655,
			{ ic: .011 }
		],
		8116: [
			.711,
			.243,
			.655,
			{ ic: .011 }
		],
		8118: [
			.694,
			.005,
			.655,
			{ ic: .011 }
		],
		8119: [
			.694,
			.243,
			.655,
			{ ic: .011 }
		],
		8120: [
			.935,
			0,
			.933
		],
		8121: [
			.799,
			0,
			.933
		],
		8122: [
			.711,
			0,
			.928
		],
		8123: [
			.711,
			0,
			.913
		],
		8124: [
			.698,
			.244,
			.933
		],
		8125: [
			.694,
			-.5,
			.294
		],
		8126: [
			.155,
			.155,
			.294
		],
		8127: [
			.694,
			-.5,
			.294
		],
		8128: [
			.694,
			-.598,
			.428
		],
		8129: [
			.694,
			-.468,
			.561
		],
		8130: [
			.711,
			.261,
			.628
		],
		8131: [
			.455,
			.261,
			.628
		],
		8132: [
			.711,
			.261,
			.628
		],
		8134: [
			.694,
			.261,
			.628
		],
		8135: [
			.694,
			.261,
			.628
		],
		8136: [
			.711,
			0,
			1.044
		],
		8137: [
			.711,
			0,
			1.044
		],
		8138: [
			.711,
			0,
			1.192
		],
		8139: [
			.711,
			0,
			1.192
		],
		8140: [
			.686,
			.244,
			.964
		],
		8141: [
			.711,
			-.489,
			.361
		],
		8142: [
			.711,
			-.489,
			.361
		],
		8143: [
			.694,
			-.49,
			.428
		],
		8144: [
			.69,
			.009,
			.355,
			{ ic: .021 }
		],
		8145: [
			.554,
			.009,
			.355,
			{ ic: .021 }
		],
		8146: [
			.711,
			.009,
			.328,
			{ ic: .078 }
		],
		8147: [
			.711,
			.009,
			.328,
			{ ic: .078 }
		],
		8150: [
			.694,
			.009,
			.328,
			{ ic: .014 }
		],
		8151: [
			.694,
			.009,
			.328,
			{ ic: .014 }
		],
		8152: [
			.934,
			0,
			.475
		],
		8153: [
			.798,
			0,
			.475
		],
		8154: [
			.711,
			0,
			.703
		],
		8155: [
			.711,
			0,
			.703
		],
		8157: [
			.711,
			-.489,
			.361
		],
		8158: [
			.711,
			-.489,
			.361
		],
		8159: [
			.694,
			-.49,
			.428
		],
		8160: [
			.704,
			.005,
			.655
		],
		8161: [
			.568,
			.005,
			.655
		],
		8162: [
			.711,
			.005,
			.628
		],
		8163: [
			.711,
			.005,
			.628
		],
		8164: [
			.694,
			.256,
			.594
		],
		8165: [
			.694,
			.256,
			.594
		],
		8166: [
			.694,
			.005,
			.628
		],
		8167: [
			.694,
			.005,
			.628
		],
		8168: [
			.934,
			0,
			.961
		],
		8169: [
			.798,
			0,
			.961
		],
		8170: [
			.711,
			0,
			1.189
		],
		8171: [
			.711,
			0,
			1.189
		],
		8172: [
			.694,
			0,
			1.141
		],
		8173: [
			.711,
			-.489,
			.328,
			{ ic: .078 }
		],
		8174: [
			.711,
			-.489,
			.328,
			{ ic: .078 }
		],
		8175: [
			.711,
			-.489,
			.228
		],
		8178: [
			.711,
			.243,
			.828
		],
		8179: [
			.454,
			.243,
			.828
		],
		8180: [
			.711,
			.243,
			.828
		],
		8182: [
			.694,
			.005,
			.828
		],
		8183: [
			.694,
			.243,
			.828
		],
		8184: [
			.711,
			.011,
			1.091
		],
		8185: [
			.711,
			.011,
			1.044
		],
		8186: [
			.711,
			0,
			1.089
		],
		8187: [
			.711,
			0,
			1.008
		],
		8188: [
			.697,
			.244,
			.894
		],
		8189: [
			.711,
			-.489,
			.228
		],
		8190: [
			.694,
			-.5,
			.294
		],
		11392: [
			.672,
			.007,
			.75
		],
		11393: [
			.432,
			.01,
			.566
		],
		11394: [
			.686,
			0,
			.818
		],
		11395: [
			.445,
			0,
			.575
		],
		11396: [
			.68,
			0,
			.692
		],
		11397: [
			.445,
			0,
			.496
		],
		11398: [
			.672,
			0,
			.75
		],
		11399: [
			.432,
			0,
			.556
		],
		11400: [
			.697,
			.011,
			.831
		],
		11401: [
			.453,
			.006,
			.489
		],
		11402: [
			.715,
			.143,
			.813
		],
		11403: [
			.476,
			.187,
			.625
		],
		11404: [
			.686,
			.091,
			.605
		],
		11405: [
			.43,
			.069,
			.419
		],
		11406: [
			.686,
			0,
			.9
		],
		11407: [
			.445,
			0,
			.639
		],
		11408: [
			.697,
			.011,
			.894
		],
		11409: [
			.455,
			.011,
			.511
		],
		11410: [
			.686,
			0,
			.436
		],
		11411: [
			.445,
			0,
			.275
		],
		11412: [
			.686,
			0,
			.901
		],
		11413: [
			.445,
			0,
			.639
		],
		11414: [
			.685,
			0,
			.806
		],
		11415: [
			.444,
			.003,
			.554
		],
		11416: [
			.684,
			.012,
			1.127
		],
		11417: [
			.431,
			.008,
			.749
		],
		11418: [
			.686,
			0,
			.9
		],
		11419: [
			.445,
			0,
			.659
		],
		11420: [
			.677,
			.106,
			.637
		],
		11421: [
			.431,
			.074,
			.402
		],
		11422: [
			.697,
			.011,
			.864
		],
		11423: [
			.453,
			.006,
			.575
		],
		11424: [
			.68,
			0,
			.9
		],
		11425: [
			.445,
			0,
			.639
		],
		11426: [
			.686,
			0,
			.786
		],
		11427: [
			.445,
			0,
			.567
		],
		11428: [
			.697,
			.011,
			.831
		],
		11429: [
			.453,
			.006,
			.511
		],
		11430: [
			.675,
			0,
			.8
		],
		11431: [
			.445,
			0,
			.544
		],
		11432: [
			.686,
			0,
			.869
		],
		11433: [
			.445,
			0,
			.609
		],
		11434: [
			.686,
			0,
			.831
		],
		11435: [
			.446,
			.109,
			.518
		],
		11436: [
			.686,
			0,
			.869
		],
		11437: [
			.445,
			0,
			.607
		],
		11438: [
			.686,
			0,
			.894
		],
		11439: [
			.445,
			0,
			.588
		],
		11440: [
			.707,
			.03,
			.982
		],
		11441: [
			.434,
			.023,
			.789
		],
		11442: [
			.679,
			-.129,
			.728
		],
		11443: [
			.431,
			-.061,
			.499
		],
		11444: [
			.71,
			0,
			.49
		],
		11445: [
			.454,
			0,
			.313
		],
		11446: [
			.766,
			.089,
			.667
		],
		11447: [
			.487,
			.058,
			.533
		],
		11448: [
			.71,
			.15,
			.49
		],
		11449: [
			.454,
			.108,
			.313,
			{ ic: .004 }
		],
		11450: [
			.488,
			-.212,
			.667
		],
		11451: [
			.317,
			-.127,
			.533
		],
		11452: [
			.688,
			.012,
			.845
		],
		11453: [
			.439,
			.01,
			.606
		],
		11454: [
			.688,
			.012,
			.949
		],
		11455: [
			.439,
			.01,
			.718
		],
		11456: [
			.686,
			0,
			.786
		],
		11457: [
			.445,
			.14,
			.617
		],
		11458: [
			1.107,
			.219,
			.982
		],
		11459: [
			.819,
			.216,
			.789
		],
		11460: [
			.686,
			.011,
			.639
		],
		11461: [
			.445,
			.2,
			.511
		],
		11462: [
			.683,
			.167,
			.409
		],
		11463: [
			.443,
			.123,
			.25
		],
		11464: [
			.666,
			.134,
			.51
		],
		11465: [
			.466,
			.134,
			.6
		],
		11466: [
			.694,
			.109,
			.488
		],
		11467: [
			.43,
			.078,
			.355
		],
		11468: [
			.655,
			.011,
			.535
		],
		11469: [
			.473,
			.127,
			.43
		],
		11470: [
			.686,
			.169,
			.786
		],
		11471: [
			.445,
			.122,
			.567
		],
		11472: [
			.686,
			0,
			.692
		],
		11473: [
			.445,
			0,
			.496
		],
		11474: [
			.676,
			.027,
			.488
		],
		11475: [
			.497,
			.011,
			.355
		],
		11476: [
			.873,
			0,
			.436
		],
		11477: [
			.608,
			0,
			.325
		],
		11478: [
			.686,
			.186,
			.692
		],
		11479: [
			.445,
			.148,
			.496
		],
		11480: [
			.68,
			0,
			.9
		],
		11481: [
			.445,
			0,
			.639
		],
		11482: [
			.672,
			0,
			.75
		],
		11483: [
			.432,
			0,
			.556
		],
		11484: [
			.899,
			.011,
			.864
		],
		11485: [
			.638,
			.006,
			.575
		],
		11486: [
			.68,
			.001,
			.692
		],
		11487: [
			.445,
			.001,
			.496
		],
		11488: [
			.681,
			.401,
			.817
		],
		11489: [
			.454,
			.268,
			.623
		],
		11490: [
			.675,
			.221,
			.8
		],
		11491: [
			.445,
			.165,
			.544
		],
		11492: [
			.446,
			.253,
			.602
		],
		11493: [
			.723,
			.161,
			.749
		],
		11494: [
			.723,
			.161,
			.749
		],
		11495: [
			.833,
			.161,
			1.099
		],
		11496: [
			.708,
			.161,
			.691
		],
		11497: [
			.723,
			.146,
			.736
		],
		11498: [
			.453,
			.006,
			1.074
		],
		11499: [
			.689,
			-.054,
			.951
		],
		11500: [
			.474,
			-.046,
			.653
		],
		11501: [
			.688,
			.012,
			.741
		],
		11502: [
			.439,
			.01,
			.598
		],
		11503: [
			.698,
			-.498,
			.533
		],
		11504: [
			.782,
			-.614,
			0,
			{ dx: .281 }
		],
		11505: [
			.782,
			-.614,
			0,
			{ dx: .23 }
		],
		11506: [
			.76,
			.022,
			.804
		],
		11507: [
			.503,
			.014,
			.52
		],
		11513: [
			.57,
			0,
			.893
		],
		11514: [
			.57,
			.009,
			.573
		],
		11515: [
			.57,
			.009,
			.573
		],
		11516: [
			.57,
			0,
			.893
		],
		11517: [
			.444,
			.009,
			.241
		],
		11518: [
			.419,
			.025,
			.363
		],
		11519: [
			.582,
			-.355,
			.313
		]
	} },
	GKI: { italic: {
		880: [
			.683,
			0,
			.629
		],
		881: [
			.514,
			0,
			.562
		],
		882: [
			.677,
			0,
			.716,
			{ ic: .09 }
		],
		883: [
			.506,
			0,
			.572
		],
		884: [
			.7,
			-.477,
			.194,
			{ ic: .134 }
		],
		885: [
			.005,
			.217,
			.194
		],
		886: [
			.683,
			0,
			.743,
			{ ic: .092 }
		],
		887: [
			.514,
			0,
			.743
		],
		890: [
			-.064,
			.25,
			.111
		],
		891: [
			.528,
			.014,
			.591,
			{ ic: .031 }
		],
		892: [
			.528,
			.014,
			.591,
			{ ic: .077 }
		],
		893: [
			.528,
			.014,
			.591,
			{ ic: .031 }
		],
		894: [
			.43,
			.192,
			.278,
			{ ic: .008 }
		],
		895: [
			.683,
			.022,
			.525,
			{ ic: .097 }
		],
		900: [
			.7,
			-.478,
			.167,
			{ ic: .138 }
		],
		901: [
			.7,
			-.478,
			.278,
			{ ic: .111 }
		],
		902: [
			.716,
			0,
			.75
		],
		903: [
			.43,
			-.323,
			.278
		],
		904: [
			.7,
			0,
			.847,
			{ ic: .087 }
		],
		905: [
			.7,
			0,
			.917,
			{ ic: .137 }
		],
		906: [
			.7,
			0,
			.528,
			{ ic: .142 }
		],
		908: [
			.705,
			.022,
			.861,
			{ ic: .04 }
		],
		910: [
			.7,
			0,
			.861,
			{ ic: .161 }
		],
		911: [
			.705,
			0,
			.805,
			{ ic: .063 }
		],
		912: [
			.7,
			.011,
			.25,
			{ ic: .125 }
		],
		938: [
			.833,
			0,
			.361,
			{ ic: .128 }
		],
		939: [
			.833,
			0,
			.778,
			{ ic: .065 }
		],
		940: [
			.7,
			.014,
			.5
		],
		941: [
			.7,
			.01,
			.43,
			{ ic: .037 }
		],
		942: [
			.708,
			.25,
			.555,
			{ ic: .004 }
		],
		943: [
			.7,
			.011,
			.25,
			{ ic: .125 }
		],
		944: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		970: [
			.625,
			.011,
			.25,
			{ ic: .155 }
		],
		971: [
			.625,
			.011,
			.5,
			{ ic: .025 }
		],
		972: [
			.7,
			.01,
			.472,
			{ ic: .021 }
		],
		973: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		974: [
			.7,
			.012,
			.667,
			{ ic: .007 }
		],
		975: [
			.683,
			.261,
			.764,
			{ ic: .078 }
		],
		976: [
			.705,
			.011,
			.474,
			{ ic: .053 }
		],
		979: [
			.722,
			0,
			.778,
			{ ic: .007 }
		],
		980: [
			.828,
			0,
			.778,
			{ ic: .007 }
		],
		983: [
			.456,
			.261,
			.528,
			{ ic: .047 }
		],
		984: [
			.695,
			.002,
			.5,
			{ ic: .076 }
		],
		985: [
			.603,
			.05,
			.5,
			{ ic: .031 }
		],
		986: [
			.677,
			0,
			.778,
			{ ic: .113 }
		],
		987: [
			.444,
			0,
			.5,
			{ ic: .037 }
		],
		988: [
			.681,
			0,
			.653,
			{ ic: .073 }
		],
		989: [
			.43,
			.25,
			.5,
			{ ic: .035 }
		],
		990: [
			.681,
			.006,
			.389
		],
		991: [
			.599,
			.139,
			.389
		],
		992: [
			.694,
			.001,
			.766
		],
		993: [
			.705,
			0,
			.722
		],
		994: [
			.705,
			.219,
			.982,
			{ ic: .012 }
		],
		995: [
			.433,
			.216,
			.789,
			{ ic: .017 }
		],
		996: [
			.687,
			.19,
			.658,
			{ ic: .081 }
		],
		997: [
			.437,
			.279,
			.535,
			{ ic: .061 }
		],
		998: [
			.683,
			.205,
			.698
		],
		999: [
			.459,
			.205,
			.555
		],
		1e3: [
			.666,
			.134,
			.51,
			{ ic: .031 }
		],
		1001: [
			.466,
			.134,
			.484,
			{ ic: .009 }
		],
		1002: [
			.705,
			0,
			.75,
			{ ic: .047 }
		],
		1003: [
			.433,
			0,
			.528,
			{ ic: .001 }
		],
		1004: [
			.684,
			.011,
			.5,
			{ ic: .032 }
		],
		1005: [
			.465,
			.009,
			.5,
			{ ic: .03 }
		],
		1006: [
			.683,
			0,
			.716
		],
		1007: [
			.654,
			0,
			.458
		],
		1010: [
			.448,
			.011,
			.444,
			{ ic: .009 }
		],
		1011: [
			.657,
			.211,
			.266,
			{ ic: .048 }
		],
		1015: [
			.683,
			0,
			.625
		],
		1016: [
			.73,
			.28,
			.472
		],
		1017: [
			.705,
			.022,
			.722
		],
		1018: [
			.683,
			0,
			.916
		],
		1019: [
			.43,
			.166,
			.583,
			{ ic: .07 }
		],
		1020: [
			.446,
			.26,
			.472,
			{ ic: .005 }
		],
		1021: [
			.705,
			.022,
			.722
		],
		1022: [
			.705,
			.022,
			.722
		],
		1023: [
			.705,
			.022,
			.722
		],
		7936: [
			.694,
			.014,
			.5
		],
		7937: [
			.694,
			.014,
			.5
		],
		7938: [
			.7,
			.014,
			.5
		],
		7939: [
			.7,
			.014,
			.5
		],
		7940: [
			.7,
			.014,
			.5,
			{ ic: .024 }
		],
		7941: [
			.7,
			.014,
			.5,
			{ ic: .024 }
		],
		7942: [
			.694,
			.014,
			.5,
			{ ic: .042 }
		],
		7943: [
			.694,
			.014,
			.5,
			{ ic: .042 }
		],
		7944: [
			.716,
			0,
			.833
		],
		7945: [
			.716,
			0,
			.805
		],
		7946: [
			.716,
			0,
			.945
		],
		7947: [
			.716,
			0,
			.945
		],
		7948: [
			.716,
			0,
			.945
		],
		7949: [
			.716,
			0,
			.945
		],
		7950: [
			.716,
			0,
			.972
		],
		7951: [
			.716,
			0,
			.972
		],
		7952: [
			.694,
			.01,
			.43,
			{ ic: .037 }
		],
		7953: [
			.694,
			.01,
			.43,
			{ ic: .037 }
		],
		7954: [
			.7,
			.01,
			.43,
			{ ic: .044 }
		],
		7955: [
			.7,
			.01,
			.43,
			{ ic: .044 }
		],
		7956: [
			.7,
			.01,
			.43,
			{ ic: .077 }
		],
		7957: [
			.7,
			.01,
			.43,
			{ ic: .077 }
		],
		7960: [
			.694,
			0,
			.902,
			{ ic: .087 }
		],
		7961: [
			.694,
			0,
			.902,
			{ ic: .087 }
		],
		7962: [
			.7,
			0,
			.958,
			{ ic: .087 }
		],
		7963: [
			.7,
			0,
			.958,
			{ ic: .087 }
		],
		7964: [
			.7,
			0,
			.958,
			{ ic: .087 }
		],
		7965: [
			.7,
			0,
			.958,
			{ ic: .087 }
		],
		7968: [
			.694,
			.25,
			.555,
			{ ic: .004 }
		],
		7969: [
			.694,
			.25,
			.555,
			{ ic: .004 }
		],
		7970: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		7971: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		7972: [
			.7,
			.25,
			.555,
			{ ic: .007 }
		],
		7973: [
			.7,
			.25,
			.555,
			{ ic: .007 }
		],
		7974: [
			.694,
			.25,
			.555,
			{ ic: .035 }
		],
		7975: [
			.694,
			.25,
			.555,
			{ ic: .035 }
		],
		7976: [
			.694,
			0,
			.972,
			{ ic: .137 }
		],
		7977: [
			.694,
			0,
			.972,
			{ ic: .137 }
		],
		7978: [
			.7,
			0,
			1.028,
			{ ic: .137 }
		],
		7979: [
			.7,
			0,
			1.028,
			{ ic: .137 }
		],
		7980: [
			.7,
			0,
			1.028,
			{ ic: .137 }
		],
		7981: [
			.7,
			0,
			1.028,
			{ ic: .137 }
		],
		7982: [
			.695,
			0,
			1.083,
			{ ic: .137 }
		],
		7983: [
			.695,
			0,
			1.083,
			{ ic: .137 }
		],
		7984: [
			.694,
			.011,
			.25,
			{ ic: .087 }
		],
		7985: [
			.694,
			.011,
			.25,
			{ ic: .068 }
		],
		7986: [
			.7,
			.011,
			.25,
			{ ic: .135 }
		],
		7987: [
			.7,
			.011,
			.25,
			{ ic: .135 }
		],
		7988: [
			.7,
			.011,
			.25,
			{ ic: .167 }
		],
		7989: [
			.7,
			.011,
			.25,
			{ ic: .167 }
		],
		7990: [
			.694,
			.011,
			.25,
			{ ic: .185 }
		],
		7991: [
			.694,
			.011,
			.25,
			{ ic: .185 }
		],
		7992: [
			.694,
			0,
			.583,
			{ ic: .142 }
		],
		7993: [
			.694,
			0,
			.583,
			{ ic: .142 }
		],
		7994: [
			.7,
			0,
			.639,
			{ ic: .142 }
		],
		7995: [
			.7,
			0,
			.639,
			{ ic: .142 }
		],
		7996: [
			.7,
			0,
			.639,
			{ ic: .142 }
		],
		7997: [
			.7,
			0,
			.639,
			{ ic: .142 }
		],
		7998: [
			.695,
			0,
			.694,
			{ ic: .142 }
		],
		7999: [
			.695,
			0,
			.694,
			{ ic: .142 }
		],
		8e3: [
			.694,
			.01,
			.472,
			{ ic: .021 }
		],
		8001: [
			.694,
			.01,
			.472,
			{ ic: .021 }
		],
		8002: [
			.7,
			.01,
			.472,
			{ ic: .023 }
		],
		8003: [
			.7,
			.01,
			.472,
			{ ic: .023 }
		],
		8004: [
			.7,
			.01,
			.472,
			{ ic: .056 }
		],
		8005: [
			.7,
			.01,
			.472,
			{ ic: .056 }
		],
		8008: [
			.705,
			.022,
			.944,
			{ ic: .04 }
		],
		8009: [
			.705,
			.022,
			.944,
			{ ic: .04 }
		],
		8010: [
			.705,
			.022,
			1.028,
			{ ic: .04 }
		],
		8011: [
			.705,
			.022,
			1.028,
			{ ic: .04 }
		],
		8012: [
			.705,
			.022,
			1.028,
			{ ic: .04 }
		],
		8013: [
			.705,
			.022,
			1.028,
			{ ic: .04 }
		],
		8016: [
			.694,
			.011,
			.5,
			{ ic: .025 }
		],
		8017: [
			.694,
			.011,
			.5,
			{ ic: .025 }
		],
		8018: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		8019: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		8020: [
			.7,
			.011,
			.5,
			{ ic: .033 }
		],
		8021: [
			.7,
			.011,
			.5,
			{ ic: .033 }
		],
		8022: [
			.694,
			.011,
			.5,
			{ ic: .052 }
		],
		8023: [
			.694,
			.011,
			.5,
			{ ic: .052 }
		],
		8025: [
			.694,
			0,
			.916,
			{ ic: .161 }
		],
		8027: [
			.7,
			0,
			.972,
			{ ic: .161 }
		],
		8029: [
			.7,
			0,
			.972,
			{ ic: .161 }
		],
		8031: [
			.695,
			0,
			1.027,
			{ ic: .161 }
		],
		8032: [
			.694,
			.012,
			.667,
			{ ic: .007 }
		],
		8033: [
			.694,
			.012,
			.667,
			{ ic: .007 }
		],
		8034: [
			.706,
			.012,
			.667,
			{ ic: .007 }
		],
		8035: [
			.706,
			.012,
			.667,
			{ ic: .007 }
		],
		8036: [
			.7,
			.012,
			.667,
			{ ic: .007 }
		],
		8037: [
			.7,
			.012,
			.667,
			{ ic: .007 }
		],
		8038: [
			.694,
			.012,
			.667,
			{ ic: .033 }
		],
		8039: [
			.694,
			.012,
			.667,
			{ ic: .033 }
		],
		8040: [
			.705,
			0,
			.916,
			{ ic: .063 }
		],
		8041: [
			.705,
			0,
			.916,
			{ ic: .063 }
		],
		8042: [
			.705,
			0,
			1,
			{ ic: .063 }
		],
		8043: [
			.705,
			0,
			1,
			{ ic: .063 }
		],
		8044: [
			.705,
			0,
			1,
			{ ic: .063 }
		],
		8045: [
			.705,
			0,
			1,
			{ ic: .063 }
		],
		8046: [
			.705,
			0,
			1.055,
			{ ic: .063 }
		],
		8047: [
			.705,
			0,
			1.055,
			{ ic: .063 }
		],
		8048: [
			.7,
			.014,
			.5
		],
		8049: [
			.7,
			.014,
			.5,
			{ ic: .007 }
		],
		8050: [
			.7,
			.01,
			.43,
			{ ic: .037 }
		],
		8051: [
			.7,
			.01,
			.43,
			{ ic: .077 }
		],
		8052: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		8053: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		8054: [
			.7,
			.011,
			.25,
			{ ic: .017 }
		],
		8055: [
			.7,
			.011,
			.25,
			{ ic: .127 }
		],
		8056: [
			.7,
			.01,
			.472,
			{ ic: .021 }
		],
		8057: [
			.7,
			.01,
			.472,
			{ ic: .035 }
		],
		8058: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		8059: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		8060: [
			.7,
			.012,
			.667,
			{ ic: .007 }
		],
		8061: [
			.7,
			.012,
			.667,
			{ ic: .007 }
		],
		8064: [
			.694,
			.25,
			.5
		],
		8065: [
			.694,
			.25,
			.5
		],
		8066: [
			.7,
			.25,
			.5
		],
		8067: [
			.7,
			.25,
			.5
		],
		8068: [
			.7,
			.25,
			.5,
			{ ic: .024 }
		],
		8069: [
			.7,
			.25,
			.5,
			{ ic: .024 }
		],
		8070: [
			.694,
			.25,
			.5,
			{ ic: .042 }
		],
		8071: [
			.694,
			.25,
			.5,
			{ ic: .042 }
		],
		8072: [
			.716,
			.267,
			.833
		],
		8073: [
			.716,
			.267,
			.805
		],
		8074: [
			.716,
			.267,
			.945
		],
		8075: [
			.716,
			.267,
			.945
		],
		8076: [
			.716,
			.267,
			.945
		],
		8077: [
			.716,
			.267,
			.945
		],
		8078: [
			.716,
			.267,
			.972
		],
		8079: [
			.716,
			.267,
			.972
		],
		8080: [
			.694,
			.25,
			.555,
			{ ic: .004 }
		],
		8081: [
			.694,
			.25,
			.555,
			{ ic: .004 }
		],
		8082: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		8083: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		8084: [
			.7,
			.25,
			.555,
			{ ic: .007 }
		],
		8085: [
			.7,
			.25,
			.555,
			{ ic: .007 }
		],
		8086: [
			.694,
			.25,
			.555,
			{ ic: .035 }
		],
		8087: [
			.694,
			.25,
			.555,
			{ ic: .035 }
		],
		8088: [
			.694,
			.267,
			.972,
			{ ic: .137 }
		],
		8089: [
			.694,
			.267,
			.972,
			{ ic: .137 }
		],
		8090: [
			.7,
			.267,
			1.028,
			{ ic: .137 }
		],
		8091: [
			.7,
			.267,
			1.028,
			{ ic: .137 }
		],
		8092: [
			.7,
			.267,
			1.028,
			{ ic: .137 }
		],
		8093: [
			.7,
			.267,
			1.028,
			{ ic: .137 }
		],
		8094: [
			.695,
			.267,
			1.083,
			{ ic: .137 }
		],
		8095: [
			.695,
			.267,
			1.083,
			{ ic: .137 }
		],
		8096: [
			.694,
			.25,
			.667,
			{ ic: .007 }
		],
		8097: [
			.694,
			.25,
			.667,
			{ ic: .007 }
		],
		8098: [
			.706,
			.25,
			.667,
			{ ic: .007 }
		],
		8099: [
			.706,
			.25,
			.667,
			{ ic: .007 }
		],
		8100: [
			.7,
			.25,
			.667,
			{ ic: .007 }
		],
		8101: [
			.7,
			.25,
			.667,
			{ ic: .007 }
		],
		8102: [
			.694,
			.25,
			.667,
			{ ic: .033 }
		],
		8103: [
			.694,
			.25,
			.667,
			{ ic: .033 }
		],
		8104: [
			.705,
			.267,
			.916,
			{ ic: .063 }
		],
		8105: [
			.705,
			.267,
			.916,
			{ ic: .063 }
		],
		8106: [
			.705,
			.267,
			1,
			{ ic: .063 }
		],
		8107: [
			.705,
			.267,
			1,
			{ ic: .063 }
		],
		8108: [
			.705,
			.267,
			1,
			{ ic: .063 }
		],
		8109: [
			.705,
			.267,
			1,
			{ ic: .063 }
		],
		8110: [
			.705,
			.267,
			1.055,
			{ ic: .063 }
		],
		8111: [
			.705,
			.267,
			1.055,
			{ ic: .063 }
		],
		8112: [
			.705,
			.014,
			.555,
			{ ic: .087 }
		],
		8113: [
			.565,
			.014,
			.555,
			{ ic: .039 }
		],
		8114: [
			.7,
			.25,
			.5
		],
		8115: [
			.441,
			.25,
			.5
		],
		8116: [
			.7,
			.25,
			.5
		],
		8118: [
			.625,
			.014,
			.5,
			{ ic: .038 }
		],
		8119: [
			.625,
			.25,
			.5,
			{ ic: .037 }
		],
		8120: [
			.979,
			0,
			.75,
			{ ic: .065 }
		],
		8121: [
			.839,
			0,
			.75,
			{ ic: .03 }
		],
		8122: [
			.716,
			0,
			.806
		],
		8123: [
			.716,
			0,
			.75
		],
		8124: [
			.716,
			.267,
			.75
		],
		8125: [
			.694,
			-.496,
			.222,
			{ ic: .139 }
		],
		8126: [
			.157,
			.158,
			.222,
			{ ic: .005 }
		],
		8127: [
			.694,
			-.494,
			.222,
			{ ic: .115 }
		],
		8128: [
			.625,
			-.527,
			.333,
			{ ic: .141 }
		],
		8129: [
			.694,
			-.481,
			.444,
			{ ic: .089 }
		],
		8130: [
			.7,
			.25,
			.555,
			{ ic: .004 }
		],
		8131: [
			.441,
			.25,
			.555,
			{ ic: .004 }
		],
		8132: [
			.701,
			.25,
			.555,
			{ ic: .004 }
		],
		8134: [
			.626,
			.25,
			.555,
			{ ic: .024 }
		],
		8135: [
			.626,
			.25,
			.555,
			{ ic: .024 }
		],
		8136: [
			.7,
			0,
			.847,
			{ ic: .087 }
		],
		8137: [
			.7,
			0,
			.847,
			{ ic: .087 }
		],
		8138: [
			.7,
			0,
			.917,
			{ ic: .137 }
		],
		8139: [
			.7,
			0,
			.917,
			{ ic: .137 }
		],
		8140: [
			.683,
			.267,
			.75,
			{ ic: .137 }
		],
		8141: [
			.7,
			-.478,
			.278,
			{ ic: .121 }
		],
		8142: [
			.7,
			-.478,
			.278,
			{ ic: .153 }
		],
		8143: [
			.694,
			-.473,
			.333,
			{ ic: .144 }
		],
		8144: [
			.705,
			.011,
			.25,
			{ ic: .201 }
		],
		8145: [
			.565,
			.011,
			.25,
			{ ic: .166 }
		],
		8146: [
			.7,
			.011,
			.25,
			{ ic: .114 }
		],
		8147: [
			.7,
			.011,
			.25,
			{ ic: .12 }
		],
		8150: [
			.625,
			.011,
			.25,
			{ ic: .178 }
		],
		8151: [
			.694,
			.011,
			.25,
			{ ic: .185 }
		],
		8152: [
			.968,
			0,
			.361,
			{ ic: .253 }
		],
		8153: [
			.828,
			0,
			.361,
			{ ic: .219 }
		],
		8154: [
			.7,
			0,
			.528,
			{ ic: .142 }
		],
		8155: [
			.7,
			0,
			.528,
			{ ic: .142 }
		],
		8157: [
			.7,
			-.478,
			.278,
			{ ic: .121 }
		],
		8158: [
			.7,
			-.478,
			.278,
			{ ic: .153 }
		],
		8159: [
			.694,
			-.473,
			.333,
			{ ic: .144 }
		],
		8160: [
			.705,
			.011,
			.517,
			{ ic: .079 }
		],
		8161: [
			.565,
			.011,
			.517,
			{ ic: .024 }
		],
		8162: [
			.7,
			.011,
			.5,
			{ ic: .025 }
		],
		8163: [
			.7,
			.011,
			.5,
			{ ic: .031 }
		],
		8164: [
			.694,
			.25,
			.472,
			{ ic: .011 }
		],
		8165: [
			.694,
			.25,
			.472,
			{ ic: .011 }
		],
		8166: [
			.625,
			.011,
			.5,
			{ ic: .037 }
		],
		8167: [
			.694,
			.011,
			.5,
			{ ic: .052 }
		],
		8168: [
			.968,
			0,
			.694,
			{ ic: .161 }
		],
		8169: [
			.828,
			0,
			.694,
			{ ic: .161 }
		],
		8170: [
			.7,
			0,
			.861,
			{ ic: .161 }
		],
		8171: [
			.7,
			0,
			.861,
			{ ic: .161 }
		],
		8172: [
			.694,
			0,
			.902,
			{ ic: .073 }
		],
		8173: [
			.7,
			-.473,
			.278,
			{ ic: .1 }
		],
		8174: [
			.7,
			-.479,
			.278,
			{ ic: .145 }
		],
		8175: [
			.7,
			-.478,
			.167,
			{ ic: .088 }
		],
		8178: [
			.7,
			.25,
			.667,
			{ ic: .007 }
		],
		8179: [
			.43,
			.25,
			.667,
			{ ic: .007 }
		],
		8180: [
			.7,
			.25,
			.667,
			{ ic: .007 }
		],
		8182: [
			.625,
			.012,
			.667,
			{ ic: .021 }
		],
		8183: [
			.625,
			.25,
			.667,
			{ ic: .021 }
		],
		8184: [
			.705,
			.022,
			.889,
			{ ic: .04 }
		],
		8185: [
			.705,
			.022,
			.861,
			{ ic: .04 }
		],
		8186: [
			.705,
			0,
			.861,
			{ ic: .063 }
		],
		8187: [
			.705,
			0,
			.805,
			{ ic: .063 }
		],
		8188: [
			.705,
			.267,
			.722,
			{ ic: .063 }
		],
		8189: [
			.7,
			-.479,
			.167,
			{ ic: .137 }
		],
		8190: [
			.694,
			-.495,
			.222,
			{ ic: .069 }
		],
		11392: [
			.672,
			.007,
			.75
		],
		11393: [
			.432,
			.01,
			.566
		],
		11394: [
			.683,
			0,
			.708
		],
		11395: [
			.43,
			0,
			.5
		],
		11396: [
			.68,
			0,
			.625,
			{ ic: .016 }
		],
		11397: [
			.43,
			0,
			.472
		],
		11398: [
			.672,
			0,
			.75
		],
		11399: [
			.432,
			0,
			.576
		],
		11400: [
			.705,
			.022,
			.681,
			{ ic: .044 }
		],
		11401: [
			.447,
			.011,
			.438,
			{ ic: .007 }
		],
		11402: [
			.716,
			.1,
			.813,
			{ ic: .065 }
		],
		11403: [
			.476,
			.177,
			.625,
			{ ic: .05 }
		],
		11404: [
			.683,
			.086,
			.605,
			{ ic: .075 }
		],
		11405: [
			.43,
			.063,
			.419,
			{ ic: .029 }
		],
		11406: [
			.683,
			0,
			.75,
			{ ic: .053 }
		],
		11407: [
			.43,
			0,
			.555,
			{ ic: .029 }
		],
		11408: [
			.705,
			.022,
			.778
		],
		11409: [
			.447,
			.011,
			.5,
			{ ic: .003 }
		],
		11410: [
			.683,
			0,
			.361,
			{ ic: .059 }
		],
		11411: [
			.43,
			0,
			.25,
			{ ic: .043 }
		],
		11412: [
			.683,
			0,
			.778,
			{ ic: .031 }
		],
		11413: [
			.43,
			0,
			.555,
			{ ic: .016 }
		],
		11414: [
			.684,
			0,
			.694
		],
		11415: [
			.43,
			0,
			.475
		],
		11416: [
			.683,
			.012,
			1.127
		],
		11417: [
			.43,
			.008,
			.749
		],
		11418: [
			.683,
			0,
			.75,
			{ ic: .053 }
		],
		11419: [
			.432,
			0,
			.552,
			{ ic: .03 }
		],
		11420: [
			.677,
			.097,
			.637,
			{ ic: .033 }
		],
		11421: [
			.431,
			.074,
			.402,
			{ ic: .027 }
		],
		11422: [
			.705,
			.022,
			.778
		],
		11423: [
			.448,
			.011,
			.5,
			{ ic: .004 }
		],
		11424: [
			.68,
			0,
			.75,
			{ ic: .054 }
		],
		11425: [
			.43,
			0,
			.555,
			{ ic: .029 }
		],
		11426: [
			.684,
			0,
			.68,
			{ ic: .011 }
		],
		11427: [
			.43,
			0,
			.5,
			{ ic: .006 }
		],
		11428: [
			.705,
			.022,
			.722,
			{ ic: .034 }
		],
		11429: [
			.447,
			.011,
			.439,
			{ ic: .026 }
		],
		11430: [
			.677,
			0,
			.722,
			{ ic: .03 }
		],
		11431: [
			.43,
			0,
			.5,
			{ ic: .019 }
		],
		11432: [
			.683,
			0,
			.75,
			{ ic: .075 }
		],
		11433: [
			.431,
			0,
			.547,
			{ ic: .037 }
		],
		11434: [
			.683,
			0,
			.722
		],
		11435: [
			.43,
			.092,
			.458,
			{ ic: .004 }
		],
		11436: [
			.683,
			0,
			.75,
			{ ic: .021 }
		],
		11437: [
			.43,
			0,
			.528,
			{ ic: .026 }
		],
		11438: [
			.683,
			0,
			.778
		],
		11439: [
			.43,
			0,
			.583
		],
		11440: [
			.705,
			.022,
			1
		],
		11441: [
			.433,
			.011,
			.779,
			{ ic: .002 }
		],
		11442: [
			.678,
			-.129,
			.728
		],
		11443: [
			.43,
			-.061,
			.499
		],
		11444: [
			.697,
			0,
			.49
		],
		11445: [
			.441,
			0,
			.313
		],
		11446: [
			.763,
			.086,
			.667,
			{ ic: .076 }
		],
		11447: [
			.498,
			.069,
			.533,
			{ ic: .055 }
		],
		11448: [
			.698,
			.15,
			.524
		],
		11449: [
			.441,
			.108,
			.337
		],
		11450: [
			.473,
			-.23,
			.667
		],
		11451: [
			.321,
			-.123,
			.533,
			{ ic: .009 }
		],
		11452: [
			.685,
			.008,
			.667,
			{ ic: .043 }
		],
		11453: [
			.434,
			.005,
			.61
		],
		11454: [
			.685,
			.008,
			.843,
			{ ic: .007 }
		],
		11455: [
			.434,
			.005,
			.734,
			{ ic: .007 }
		],
		11456: [
			.684,
			0,
			.74,
			{ ic: .011 }
		],
		11457: [
			.43,
			.142,
			.5,
			{ ic: .024 }
		],
		11458: [
			1.063,
			.219,
			.982
		],
		11459: [
			.79,
			.216,
			.789
		],
		11460: [
			.683,
			.022,
			.555,
			{ ic: .042 }
		],
		11461: [
			.43,
			.205,
			.444,
			{ ic: .037 }
		],
		11462: [
			.683,
			.167,
			.409,
			{ ic: .071 }
		],
		11463: [
			.43,
			.122,
			.25,
			{ ic: .065 }
		],
		11464: [
			.666,
			.134,
			.536,
			{ ic: .005 }
		],
		11465: [
			.466,
			.134,
			.513
		],
		11466: [
			.694,
			.109,
			.488,
			{ ic: .064 }
		],
		11467: [
			.43,
			.078,
			.355,
			{ ic: .033 }
		],
		11468: [
			.666,
			.022,
			.48,
			{ ic: .004 }
		],
		11469: [
			.472,
			.126,
			.43,
			{ ic: .012 }
		],
		11470: [
			.684,
			.169,
			.63,
			{ ic: .064 }
		],
		11471: [
			.43,
			.122,
			.414,
			{ ic: .045 }
		],
		11472: [
			.683,
			0,
			.625
		],
		11473: [
			.43,
			0,
			.472
		],
		11474: [
			.669,
			.022,
			.488,
			{ ic: .023 }
		],
		11475: [
			.498,
			.01,
			.355,
			{ ic: .026 }
		],
		11476: [
			.873,
			0,
			.401
		],
		11477: [
			.608,
			0,
			.343
		],
		11478: [
			.683,
			.196,
			.687
		],
		11479: [
			.43,
			.158,
			.522
		],
		11480: [
			.68,
			0,
			.75,
			{ ic: .054 }
		],
		11481: [
			.43,
			0,
			.555,
			{ ic: .029 }
		],
		11482: [
			.672,
			0,
			.75
		],
		11483: [
			.432,
			0,
			.576
		],
		11484: [
			.899,
			.022,
			.778
		],
		11485: [
			.635,
			.011,
			.5
		],
		11486: [
			.68,
			.001,
			.625,
			{ ic: .016 }
		],
		11487: [
			.43,
			.001,
			.472
		],
		11488: [
			.681,
			.402,
			.817,
			{ ic: .05 }
		],
		11489: [
			.454,
			.268,
			.623,
			{ ic: .013 }
		],
		11490: [
			.677,
			.221,
			.742,
			{ ic: .068 }
		],
		11491: [
			.43,
			.165,
			.5,
			{ ic: .039 }
		],
		11492: [
			.43,
			.252,
			.567,
			{ ic: .035 }
		],
		11493: [
			.708,
			.162,
			.749,
			{ ic: .026 }
		],
		11494: [
			.708,
			.162,
			.648,
			{ ic: .077 }
		],
		11495: [
			.808,
			.162,
			1.143,
			{ ic: .004 }
		],
		11496: [
			.708,
			.162,
			.749
		],
		11497: [
			.708,
			.162,
			.616,
			{ ic: .079 }
		],
		11498: [
			.448,
			.011,
			.918,
			{ ic: .027 }
		],
		11499: [
			.69,
			-.06,
			.789,
			{ ic: .031 }
		],
		11500: [
			.477,
			-.023,
			.533,
			{ ic: .025 }
		],
		11501: [
			.685,
			.008,
			.667,
			{ ic: .043 }
		],
		11502: [
			.434,
			.005,
			.61
		],
		11503: [
			.697,
			-.499,
			.533
		],
		11504: [
			.782,
			-.614,
			0,
			{ dx: .286 }
		],
		11505: [
			.782,
			-.614,
			0,
			{ dx: .224 }
		],
		11506: [
			.76,
			.022,
			.778
		],
		11507: [
			.503,
			.014,
			.5
		],
		11513: [
			.564,
			0,
			.843
		],
		11514: [
			.564,
			.009,
			.573,
			{ ic: .023 }
		],
		11515: [
			.564,
			.009,
			.573
		],
		11516: [
			.564,
			0,
			.843,
			{ ic: .022 }
		],
		11517: [
			.44,
			.005,
			.241,
			{ ic: .031 }
		],
		11518: [
			.421,
			.011,
			.313
		],
		11519: [
			.574,
			-.366,
			.313
		]
	} },
	GKBI: { "bold-italic": {
		880: [
			.686,
			0,
			.654,
			{ ic: .051 }
		],
		881: [
			.516,
			0,
			.55,
			{ ic: .016 }
		],
		882: [
			.675,
			0,
			.8,
			{ ic: .105 }
		],
		883: [
			.505,
			0,
			.638,
			{ ic: .073 }
		],
		884: [
			.728,
			-.489,
			.261,
			{ ic: .111 }
		],
		885: [
			.005,
			.217,
			.261
		],
		886: [
			.686,
			0,
			.9,
			{ ic: .131 }
		],
		887: [
			.516,
			0,
			.733,
			{ ic: .082 }
		],
		890: [
			-.055,
			.249,
			.161
		],
		891: [
			.523,
			.007,
			.669
		],
		892: [
			.523,
			.007,
			.669,
			{ ic: .01 }
		],
		893: [
			.523,
			.007,
			.669
		],
		894: [
			.444,
			.193,
			.361
		],
		895: [
			.686,
			.017,
			.611,
			{ ic: .08 }
		],
		900: [
			.729,
			-.488,
			.228,
			{ ic: .117 }
		],
		901: [
			.712,
			-.488,
			.361,
			{ ic: .118 }
		],
		902: [
			.714,
			0,
			.933
		],
		903: [
			.444,
			-.288,
			.361
		],
		904: [
			.714,
			0,
			1.044,
			{ ic: .059 }
		],
		905: [
			.714,
			0,
			1.192,
			{ ic: .112 }
		],
		906: [
			.714,
			0,
			.703,
			{ ic: .117 }
		],
		908: [
			.714,
			.011,
			1.044,
			{ ic: .017 }
		],
		910: [
			.714,
			0,
			1.094,
			{ ic: .139 }
		],
		911: [
			.714,
			.002,
			1.008,
			{ ic: .038 }
		],
		912: [
			.712,
			.008,
			.328,
			{ ic: .148 }
		],
		938: [
			.887,
			0,
			.475,
			{ ic: .149 }
		],
		939: [
			.887,
			0,
			.961,
			{ ic: .038 }
		],
		940: [
			.712,
			.006,
			.655
		],
		941: [
			.712,
			.006,
			.544,
			{ ic: .042 }
		],
		942: [
			.716,
			.25,
			.694
		],
		943: [
			.712,
			.008,
			.328,
			{ ic: .114 }
		],
		944: [
			.712,
			.006,
			.628,
			{ ic: .012 }
		],
		970: [
			.694,
			.008,
			.328,
			{ ic: .196 }
		],
		971: [
			.694,
			.006,
			.628,
			{ ic: .035 }
		],
		972: [
			.712,
			.01,
			.594
		],
		973: [
			.712,
			.006,
			.628,
			{ ic: .012 }
		],
		974: [
			.712,
			.008,
			.828
		],
		975: [
			.686,
			.258,
			.901,
			{ ic: .106 }
		],
		976: [
			.705,
			.011,
			.522
		],
		979: [
			.702,
			0,
			1.032,
			{ ic: .121 }
		],
		980: [
			.886,
			0,
			.778,
			{ ic: .195 }
		],
		983: [
			.479,
			.261,
			.528,
			{ ic: .076 }
		],
		984: [
			.702,
			.004,
			.628,
			{ ic: .051 }
		],
		985: [
			.614,
			.05,
			.628,
			{ ic: .006 }
		],
		986: [
			.675,
			0,
			.961,
			{ ic: .089 }
		],
		987: [
			.461,
			0,
			.628,
			{ ic: .014 }
		],
		988: [
			.68,
			0,
			.783,
			{ ic: .048 }
		],
		989: [
			.444,
			.25,
			.628,
			{ ic: .013 }
		],
		990: [
			.695,
			.024,
			.389,
			{ ic: .06 }
		],
		991: [
			.618,
			.146,
			.494
		],
		992: [
			.704,
			0,
			.948
		],
		993: [
			.7,
			0,
			.894
		],
		994: [
			.707,
			.219,
			.982,
			{ ic: .07 }
		],
		995: [
			.434,
			.216,
			.789,
			{ ic: .042 }
		],
		996: [
			.689,
			.19,
			.738,
			{ ic: .116 }
		],
		997: [
			.451,
			.281,
			.535,
			{ ic: .078 }
		],
		998: [
			.686,
			.205,
			.731,
			{ ic: .034 }
		],
		999: [
			.46,
			.205,
			.555,
			{ ic: .02 }
		],
		1e3: [
			.666,
			.134,
			.51,
			{ ic: .094 }
		],
		1001: [
			.466,
			.134,
			.484,
			{ ic: .048 }
		],
		1002: [
			.705,
			0,
			.75,
			{ ic: .143 }
		],
		1003: [
			.433,
			.001,
			.528,
			{ ic: .05 }
		],
		1004: [
			.684,
			.011,
			.5,
			{ ic: .114 }
		],
		1005: [
			.465,
			.037,
			.5,
			{ ic: .082 }
		],
		1006: [
			.683,
			0,
			.716,
			{ ic: .09 }
		],
		1007: [
			.656,
			.001,
			.458,
			{ ic: .082 }
		],
		1010: [
			.453,
			.006,
			.498,
			{ ic: .065 }
		],
		1011: [
			.685,
			.2,
			.388,
			{ ic: .111 }
		],
		1015: [
			.683,
			0,
			.625,
			{ ic: .052 }
		],
		1016: [
			.738,
			.295,
			.472,
			{ ic: .026 }
		],
		1017: [
			.697,
			.011,
			.831,
			{ ic: .037 }
		],
		1018: [
			.683,
			0,
			.916,
			{ ic: .066 }
		],
		1019: [
			.43,
			.181,
			.657
		],
		1020: [
			.45,
			.256,
			.622,
			{ ic: .025 }
		],
		1021: [
			.697,
			.011,
			.831,
			{ ic: .072 }
		],
		1022: [
			.697,
			.011,
			.831,
			{ ic: .037 }
		],
		1023: [
			.697,
			.011,
			.831,
			{ ic: .072 }
		],
		7936: [
			.694,
			.006,
			.655
		],
		7937: [
			.711,
			.006,
			.655
		],
		7938: [
			.715,
			.006,
			.655
		],
		7939: [
			.715,
			.006,
			.655
		],
		7940: [
			.712,
			.006,
			.655
		],
		7941: [
			.712,
			.006,
			.655
		],
		7942: [
			.694,
			.006,
			.628,
			{ ic: .027 }
		],
		7943: [
			.696,
			.006,
			.655,
			{ ic: .009 }
		],
		7944: [
			.699,
			0,
			.99
		],
		7945: [
			.699,
			0,
			.977
		],
		7946: [
			.714,
			0,
			1.104
		],
		7947: [
			.714,
			0,
			1.084
		],
		7948: [
			.714,
			0,
			1.044
		],
		7949: [
			.714,
			0,
			1.054
		],
		7950: [
			.699,
			0,
			1.118
		],
		7951: [
			.699,
			0,
			1.098
		],
		7952: [
			.694,
			.006,
			.544,
			{ ic: .042 }
		],
		7953: [
			.711,
			.006,
			.544,
			{ ic: .042 }
		],
		7954: [
			.712,
			.006,
			.544,
			{ ic: .042 }
		],
		7955: [
			.712,
			.006,
			.544,
			{ ic: .042 }
		],
		7956: [
			.712,
			.006,
			.544,
			{ ic: .046 }
		],
		7957: [
			.712,
			.006,
			.544,
			{ ic: .046 }
		],
		7960: [
			.694,
			0,
			1.11,
			{ ic: .059 }
		],
		7961: [
			.694,
			0,
			1.11,
			{ ic: .059 }
		],
		7962: [
			.714,
			0,
			1.177,
			{ ic: .059 }
		],
		7963: [
			.714,
			0,
			1.177,
			{ ic: .059 }
		],
		7964: [
			.714,
			0,
			1.177,
			{ ic: .059 }
		],
		7965: [
			.714,
			0,
			1.177,
			{ ic: .059 }
		],
		7968: [
			.694,
			.25,
			.694
		],
		7969: [
			.711,
			.25,
			.694
		],
		7970: [
			.711,
			.25,
			.694
		],
		7971: [
			.711,
			.25,
			.694
		],
		7972: [
			.716,
			.25,
			.694
		],
		7973: [
			.716,
			.25,
			.694
		],
		7974: [
			.704,
			.25,
			.694,
			{ ic: .014 }
		],
		7975: [
			.704,
			.25,
			.694,
			{ ic: .014 }
		],
		7976: [
			.694,
			0,
			1.258,
			{ ic: .112 }
		],
		7977: [
			.694,
			0,
			1.258,
			{ ic: .112 }
		],
		7978: [
			.714,
			0,
			1.325,
			{ ic: .112 }
		],
		7979: [
			.714,
			0,
			1.325,
			{ ic: .112 }
		],
		7980: [
			.714,
			0,
			1.325,
			{ ic: .112 }
		],
		7981: [
			.714,
			0,
			1.325,
			{ ic: .112 }
		],
		7982: [
			.694,
			0,
			1.392,
			{ ic: .112 }
		],
		7983: [
			.694,
			0,
			1.392,
			{ ic: .112 }
		],
		7984: [
			.694,
			.008,
			.328,
			{ ic: .057 }
		],
		7985: [
			.711,
			.008,
			.328,
			{ ic: .061 }
		],
		7986: [
			.715,
			.008,
			.328,
			{ ic: .102 }
		],
		7987: [
			.715,
			.008,
			.328,
			{ ic: .102 }
		],
		7988: [
			.712,
			.008,
			.328,
			{ ic: .154 }
		],
		7989: [
			.712,
			.008,
			.328,
			{ ic: .154 }
		],
		7990: [
			.7,
			.008,
			.328,
			{ ic: .192 }
		],
		7991: [
			.7,
			.008,
			.328,
			{ ic: .192 }
		],
		7992: [
			.694,
			0,
			.769,
			{ ic: .117 }
		],
		7993: [
			.694,
			0,
			.769,
			{ ic: .117 }
		],
		7994: [
			.714,
			0,
			.836,
			{ ic: .117 }
		],
		7995: [
			.714,
			0,
			.836,
			{ ic: .117 }
		],
		7996: [
			.714,
			0,
			.836,
			{ ic: .117 }
		],
		7997: [
			.714,
			0,
			.836,
			{ ic: .117 }
		],
		7998: [
			.694,
			0,
			.903,
			{ ic: .117 }
		],
		7999: [
			.694,
			0,
			.903,
			{ ic: .117 }
		],
		8e3: [
			.694,
			.01,
			.594
		],
		8001: [
			.711,
			.01,
			.594
		],
		8002: [
			.712,
			.01,
			.594
		],
		8003: [
			.712,
			.01,
			.594
		],
		8004: [
			.712,
			.01,
			.594,
			{ ic: .007 }
		],
		8005: [
			.712,
			.01,
			.594,
			{ ic: .007 }
		],
		8008: [
			.697,
			.011,
			1.157,
			{ ic: .017 }
		],
		8009: [
			.697,
			.011,
			1.157,
			{ ic: .017 }
		],
		8010: [
			.714,
			.011,
			1.258,
			{ ic: .017 }
		],
		8011: [
			.714,
			.011,
			1.258,
			{ ic: .017 }
		],
		8012: [
			.714,
			.011,
			1.258,
			{ ic: .017 }
		],
		8013: [
			.714,
			.011,
			1.258,
			{ ic: .017 }
		],
		8016: [
			.694,
			.006,
			.628,
			{ ic: .012 }
		],
		8017: [
			.711,
			.006,
			.628,
			{ ic: .012 }
		],
		8018: [
			.715,
			.006,
			.628,
			{ ic: .012 }
		],
		8019: [
			.715,
			.006,
			.628,
			{ ic: .012 }
		],
		8020: [
			.712,
			.006,
			.628,
			{ ic: .012 }
		],
		8021: [
			.712,
			.006,
			.628,
			{ ic: .012 }
		],
		8022: [
			.694,
			.006,
			.628,
			{ ic: .032 }
		],
		8023: [
			.694,
			.006,
			.628,
			{ ic: .032 }
		],
		8025: [
			.694,
			0,
			1.16,
			{ ic: .139 }
		],
		8027: [
			.714,
			0,
			1.227,
			{ ic: .139 }
		],
		8029: [
			.714,
			0,
			1.227,
			{ ic: .139 }
		],
		8031: [
			.694,
			0,
			1.294,
			{ ic: .139 }
		],
		8032: [
			.694,
			.008,
			.828
		],
		8033: [
			.711,
			.008,
			.828
		],
		8034: [
			.712,
			.008,
			.828
		],
		8035: [
			.712,
			.008,
			.828
		],
		8036: [
			.712,
			.008,
			.828
		],
		8037: [
			.712,
			.008,
			.828
		],
		8038: [
			.704,
			.008,
			.828
		],
		8039: [
			.704,
			.008,
			.828
		],
		8040: [
			.697,
			.002,
			1.155,
			{ ic: .038 }
		],
		8041: [
			.697,
			.002,
			1.155,
			{ ic: .038 }
		],
		8042: [
			.714,
			.002,
			1.255,
			{ ic: .038 }
		],
		8043: [
			.714,
			.002,
			1.255,
			{ ic: .038 }
		],
		8044: [
			.714,
			.002,
			1.255,
			{ ic: .038 }
		],
		8045: [
			.714,
			.002,
			1.255,
			{ ic: .038 }
		],
		8046: [
			.697,
			.002,
			1.322,
			{ ic: .038 }
		],
		8047: [
			.697,
			.002,
			1.322,
			{ ic: .038 }
		],
		8048: [
			.715,
			.006,
			.655
		],
		8049: [
			.712,
			.006,
			.655
		],
		8050: [
			.712,
			.006,
			.544,
			{ ic: .042 }
		],
		8051: [
			.712,
			.006,
			.544,
			{ ic: .046 }
		],
		8052: [
			.711,
			.25,
			.694
		],
		8053: [
			.712,
			.25,
			.694
		],
		8054: [
			.715,
			.008,
			.328,
			{ ic: .038 }
		],
		8055: [
			.712,
			.008,
			.328,
			{ ic: .092 }
		],
		8056: [
			.712,
			.01,
			.594
		],
		8057: [
			.712,
			.01,
			.594
		],
		8058: [
			.715,
			.006,
			.628,
			{ ic: .012 }
		],
		8059: [
			.712,
			.006,
			.628,
			{ ic: .012 }
		],
		8060: [
			.712,
			.008,
			.828
		],
		8061: [
			.712,
			.008,
			.828
		],
		8064: [
			.694,
			.249,
			.655
		],
		8065: [
			.711,
			.249,
			.655
		],
		8066: [
			.715,
			.249,
			.655
		],
		8067: [
			.715,
			.249,
			.655
		],
		8068: [
			.712,
			.249,
			.655
		],
		8069: [
			.712,
			.249,
			.655
		],
		8070: [
			.696,
			.249,
			.655,
			{ ic: .009 }
		],
		8071: [
			.696,
			.249,
			.655,
			{ ic: .009 }
		],
		8072: [
			.699,
			.28,
			1.06
		],
		8073: [
			.699,
			.28,
			1.027
		],
		8074: [
			.714,
			.28,
			1.114
		],
		8075: [
			.714,
			.28,
			1.094
		],
		8076: [
			.714,
			.28,
			1.064
		],
		8077: [
			.714,
			.28,
			1.054
		],
		8078: [
			.699,
			.28,
			1.138
		],
		8079: [
			.699,
			.28,
			1.118
		],
		8080: [
			.694,
			.25,
			.694
		],
		8081: [
			.711,
			.25,
			.694
		],
		8082: [
			.711,
			.25,
			.694
		],
		8083: [
			.711,
			.25,
			.694
		],
		8084: [
			.716,
			.25,
			.694
		],
		8085: [
			.716,
			.25,
			.694
		],
		8086: [
			.704,
			.25,
			.694,
			{ ic: .014 }
		],
		8087: [
			.704,
			.25,
			.694,
			{ ic: .014 }
		],
		8088: [
			.694,
			.28,
			1.258,
			{ ic: .112 }
		],
		8089: [
			.694,
			.28,
			1.258,
			{ ic: .112 }
		],
		8090: [
			.714,
			.28,
			1.325,
			{ ic: .112 }
		],
		8091: [
			.714,
			.28,
			1.325,
			{ ic: .112 }
		],
		8092: [
			.714,
			.28,
			1.325,
			{ ic: .112 }
		],
		8093: [
			.714,
			.28,
			1.325,
			{ ic: .112 }
		],
		8094: [
			.694,
			.28,
			1.392,
			{ ic: .112 }
		],
		8095: [
			.694,
			.28,
			1.392,
			{ ic: .112 }
		],
		8096: [
			.694,
			.249,
			.828
		],
		8097: [
			.711,
			.249,
			.828
		],
		8098: [
			.712,
			.249,
			.828
		],
		8099: [
			.712,
			.249,
			.828
		],
		8100: [
			.712,
			.249,
			.828
		],
		8101: [
			.712,
			.249,
			.828
		],
		8102: [
			.704,
			.249,
			.828
		],
		8103: [
			.704,
			.249,
			.828
		],
		8104: [
			.697,
			.28,
			1.155,
			{ ic: .038 }
		],
		8105: [
			.697,
			.28,
			1.155,
			{ ic: .038 }
		],
		8106: [
			.714,
			.28,
			1.255,
			{ ic: .038 }
		],
		8107: [
			.714,
			.28,
			1.255,
			{ ic: .038 }
		],
		8108: [
			.714,
			.28,
			1.255,
			{ ic: .038 }
		],
		8109: [
			.714,
			.28,
			1.255,
			{ ic: .038 }
		],
		8110: [
			.697,
			.28,
			1.322,
			{ ic: .038 }
		],
		8111: [
			.697,
			.28,
			1.322,
			{ ic: .038 }
		],
		8112: [
			.732,
			.006,
			.688
		],
		8113: [
			.598,
			.006,
			.648
		],
		8114: [
			.715,
			.249,
			.655
		],
		8115: [
			.45,
			.249,
			.655
		],
		8116: [
			.712,
			.249,
			.655
		],
		8118: [
			.699,
			.006,
			.655,
			{ ic: .009 }
		],
		8119: [
			.699,
			.249,
			.655,
			{ ic: .009 }
		],
		8120: [
			.984,
			0,
			.933,
			{ ic: .011 }
		],
		8121: [
			.85,
			0,
			.933
		],
		8122: [
			.714,
			0,
			.958
		],
		8123: [
			.714,
			0,
			.923
		],
		8124: [
			.699,
			.28,
			.933
		],
		8125: [
			.694,
			-.5,
			.294,
			{ ic: .101 }
		],
		8126: [
			.156,
			.156,
			.294
		],
		8127: [
			.694,
			-.499,
			.294,
			{ ic: .078 }
		],
		8128: [
			.694,
			-.595,
			.428,
			{ ic: .129 }
		],
		8129: [
			.7,
			-.458,
			.561,
			{ ic: .062 }
		],
		8130: [
			.711,
			.25,
			.694
		],
		8131: [
			.468,
			.25,
			.694
		],
		8132: [
			.716,
			.25,
			.694
		],
		8134: [
			.708,
			.25,
			.694,
			{ ic: .014 }
		],
		8135: [
			.708,
			.25,
			.694,
			{ ic: .014 }
		],
		8136: [
			.714,
			0,
			1.044,
			{ ic: .059 }
		],
		8137: [
			.714,
			0,
			1.044,
			{ ic: .059 }
		],
		8138: [
			.714,
			0,
			1.192,
			{ ic: .112 }
		],
		8139: [
			.714,
			0,
			1.192,
			{ ic: .112 }
		],
		8140: [
			.686,
			.28,
			.964,
			{ ic: .112 }
		],
		8141: [
			.715,
			-.488,
			.361,
			{ ic: .072 }
		],
		8142: [
			.712,
			-.488,
			.361,
			{ ic: .124 }
		],
		8143: [
			.694,
			-.488,
			.428,
			{ ic: .129 }
		],
		8144: [
			.732,
			.008,
			.355,
			{ ic: .182 }
		],
		8145: [
			.598,
			.008,
			.355,
			{ ic: .149 }
		],
		8146: [
			.715,
			.008,
			.328,
			{ ic: .108 }
		],
		8147: [
			.714,
			.008,
			.328,
			{ ic: .152 }
		],
		8150: [
			.705,
			.008,
			.328,
			{ ic: .192 }
		],
		8151: [
			.7,
			.008,
			.328,
			{ ic: .192 }
		],
		8152: [
			.984,
			0,
			.475,
			{ ic: .238 }
		],
		8153: [
			.85,
			0,
			.475,
			{ ic: .205 }
		],
		8154: [
			.714,
			0,
			.703,
			{ ic: .117 }
		],
		8155: [
			.714,
			0,
			.703,
			{ ic: .117 }
		],
		8157: [
			.715,
			-.488,
			.361,
			{ ic: .072 }
		],
		8158: [
			.712,
			-.488,
			.361,
			{ ic: .124 }
		],
		8159: [
			.694,
			-.488,
			.428,
			{ ic: .129 }
		],
		8160: [
			.736,
			.006,
			.625,
			{ ic: .055 }
		],
		8161: [
			.602,
			.006,
			.635,
			{ ic: .032 }
		],
		8162: [
			.715,
			.006,
			.628,
			{ ic: .012 }
		],
		8163: [
			.714,
			.006,
			.628,
			{ ic: .031 }
		],
		8164: [
			.694,
			.25,
			.594,
			{ ic: .017 }
		],
		8165: [
			.711,
			.25,
			.594,
			{ ic: .017 }
		],
		8166: [
			.705,
			.006,
			.628,
			{ ic: .032 }
		],
		8167: [
			.694,
			.006,
			.628,
			{ ic: .032 }
		],
		8168: [
			.984,
			0,
			.866,
			{ ic: .139 }
		],
		8169: [
			.85,
			0,
			.866,
			{ ic: .139 }
		],
		8170: [
			.714,
			0,
			1.094,
			{ ic: .139 }
		],
		8171: [
			.714,
			0,
			1.094,
			{ ic: .139 }
		],
		8172: [
			.694,
			0,
			1.141,
			{ ic: .046 }
		],
		8173: [
			.715,
			-.488,
			.361,
			{ ic: .118 }
		],
		8174: [
			.714,
			-.489,
			.361,
			{ ic: .17 }
		],
		8175: [
			.711,
			-.488,
			.228,
			{ ic: .062 }
		],
		8178: [
			.712,
			.249,
			.828
		],
		8179: [
			.444,
			.249,
			.828
		],
		8180: [
			.712,
			.249,
			.828
		],
		8182: [
			.694,
			.008,
			.828
		],
		8183: [
			.694,
			.249,
			.828
		],
		8184: [
			.714,
			.011,
			1.091,
			{ ic: .017 }
		],
		8185: [
			.714,
			.011,
			1.044,
			{ ic: .017 }
		],
		8186: [
			.714,
			.002,
			1.089,
			{ ic: .038 }
		],
		8187: [
			.714,
			.002,
			1.008,
			{ ic: .038 }
		],
		8188: [
			.697,
			.28,
			.894,
			{ ic: .038 }
		],
		8189: [
			.714,
			-.49,
			.228,
			{ ic: .12 }
		],
		8190: [
			.711,
			-.499,
			.294,
			{ ic: .048 }
		],
		11392: [
			.672,
			.007,
			.75
		],
		11393: [
			.432,
			.01,
			.566
		],
		11394: [
			.686,
			0,
			.818
		],
		11395: [
			.445,
			0,
			.575
		],
		11396: [
			.68,
			0,
			.692,
			{ ic: .005 }
		],
		11397: [
			.445,
			0,
			.496,
			{ ic: .013 }
		],
		11398: [
			.672,
			0,
			.75
		],
		11399: [
			.432,
			0,
			.556
		],
		11400: [
			.697,
			.011,
			.831
		],
		11401: [
			.453,
			.006,
			.489
		],
		11402: [
			.715,
			.143,
			.813,
			{ ic: .076 }
		],
		11403: [
			.476,
			.187,
			.625,
			{ ic: .06 }
		],
		11404: [
			.686,
			.091,
			.605,
			{ ic: .074 }
		],
		11405: [
			.43,
			.069,
			.419,
			{ ic: .03 }
		],
		11406: [
			.686,
			0,
			.9,
			{ ic: .046 }
		],
		11407: [
			.445,
			0,
			.639,
			{ ic: .021 }
		],
		11408: [
			.697,
			.011,
			.894
		],
		11409: [
			.455,
			.011,
			.511,
			{ ic: .002 }
		],
		11410: [
			.686,
			0,
			.436,
			{ ic: .053 }
		],
		11411: [
			.445,
			0,
			.275,
			{ ic: .044 }
		],
		11412: [
			.686,
			0,
			.901,
			{ ic: .021 }
		],
		11413: [
			.445,
			0,
			.639,
			{ ic: .009 }
		],
		11414: [
			.685,
			0,
			.806
		],
		11415: [
			.444,
			.003,
			.554
		],
		11416: [
			.684,
			.012,
			1.127
		],
		11417: [
			.431,
			.008,
			.749
		],
		11418: [
			.686,
			0,
			.9,
			{ ic: .046 }
		],
		11419: [
			.445,
			0,
			.659,
			{ ic: .002 }
		],
		11420: [
			.677,
			.106,
			.637,
			{ ic: .034 }
		],
		11421: [
			.431,
			.074,
			.402,
			{ ic: .027 }
		],
		11422: [
			.697,
			.011,
			.864
		],
		11423: [
			.453,
			.006,
			.575
		],
		11424: [
			.68,
			0,
			.9,
			{ ic: .045 }
		],
		11425: [
			.445,
			0,
			.639,
			{ ic: .021 }
		],
		11426: [
			.686,
			0,
			.786
		],
		11427: [
			.445,
			0,
			.567,
			{ ic: .009 }
		],
		11428: [
			.697,
			.011,
			.831,
			{ ic: .023 }
		],
		11429: [
			.453,
			.006,
			.511
		],
		11430: [
			.675,
			0,
			.8,
			{ ic: .02 }
		],
		11431: [
			.445,
			0,
			.544,
			{ ic: .014 }
		],
		11432: [
			.686,
			0,
			.869,
			{ ic: .066 }
		],
		11433: [
			.445,
			0,
			.609,
			{ ic: .026 }
		],
		11434: [
			.686,
			0,
			.831
		],
		11435: [
			.446,
			.109,
			.518
		],
		11436: [
			.686,
			0,
			.869,
			{ ic: .003 }
		],
		11437: [
			.445,
			0,
			.607,
			{ ic: .013 }
		],
		11438: [
			.686,
			0,
			.894
		],
		11439: [
			.445,
			0,
			.588,
			{ ic: .002 }
		],
		11440: [
			.707,
			.03,
			.982
		],
		11441: [
			.434,
			.023,
			.789
		],
		11442: [
			.679,
			-.129,
			.728
		],
		11443: [
			.431,
			-.061,
			.499
		],
		11444: [
			.71,
			0,
			.49
		],
		11445: [
			.454,
			0,
			.313
		],
		11446: [
			.766,
			.089,
			.667,
			{ ic: .078 }
		],
		11447: [
			.487,
			.058,
			.533,
			{ ic: .053 }
		],
		11448: [
			.71,
			.15,
			.49
		],
		11449: [
			.454,
			.108,
			.313
		],
		11450: [
			.488,
			-.212,
			.667,
			{ ic: .005 }
		],
		11451: [
			.317,
			-.127,
			.533,
			{ ic: .009 }
		],
		11452: [
			.688,
			.012,
			.845
		],
		11453: [
			.439,
			.01,
			.606
		],
		11454: [
			.688,
			.012,
			.949,
			{ ic: .009 }
		],
		11455: [
			.439,
			.01,
			.718
		],
		11456: [
			.686,
			0,
			.786
		],
		11457: [
			.445,
			.14,
			.617,
			{ ic: .027 }
		],
		11458: [
			1.107,
			.219,
			.982
		],
		11459: [
			.819,
			.216,
			.789
		],
		11460: [
			.686,
			.011,
			.639,
			{ ic: .036 }
		],
		11461: [
			.445,
			.2,
			.511,
			{ ic: .028 }
		],
		11462: [
			.683,
			.167,
			.409,
			{ ic: .071 }
		],
		11463: [
			.443,
			.123,
			.25,
			{ ic: .07 }
		],
		11464: [
			.666,
			.134,
			.51,
			{ ic: .028 }
		],
		11465: [
			.466,
			.134,
			.6
		],
		11466: [
			.694,
			.109,
			.488,
			{ ic: .061 }
		],
		11467: [
			.43,
			.078,
			.355,
			{ ic: .031 }
		],
		11468: [
			.655,
			.011,
			.535
		],
		11469: [
			.473,
			.127,
			.43,
			{ ic: .009 }
		],
		11470: [
			.686,
			.169,
			.786,
			{ ic: .061 }
		],
		11471: [
			.445,
			.122,
			.567,
			{ ic: .026 }
		],
		11472: [
			.686,
			0,
			.692
		],
		11473: [
			.445,
			0,
			.496
		],
		11474: [
			.676,
			.027,
			.488,
			{ ic: .041 }
		],
		11475: [
			.497,
			.011,
			.355,
			{ ic: .023 }
		],
		11476: [
			.873,
			0,
			.436
		],
		11477: [
			.608,
			0,
			.325
		],
		11478: [
			.686,
			.186,
			.692
		],
		11479: [
			.445,
			.148,
			.496
		],
		11480: [
			.68,
			0,
			.9,
			{ ic: .045 }
		],
		11481: [
			.445,
			0,
			.639,
			{ ic: .021 }
		],
		11482: [
			.672,
			0,
			.75
		],
		11483: [
			.432,
			0,
			.556
		],
		11484: [
			.899,
			.011,
			.864
		],
		11485: [
			.638,
			.006,
			.575
		],
		11486: [
			.68,
			.001,
			.692,
			{ ic: .005 }
		],
		11487: [
			.445,
			.001,
			.496,
			{ ic: .014 }
		],
		11488: [
			.681,
			.401,
			.817,
			{ ic: .053 }
		],
		11489: [
			.454,
			.268,
			.623,
			{ ic: .014 }
		],
		11490: [
			.675,
			.221,
			.8,
			{ ic: .048 }
		],
		11491: [
			.445,
			.165,
			.544,
			{ ic: .035 }
		],
		11492: [
			.446,
			.253,
			.602,
			{ ic: .039 }
		],
		11493: [
			.723,
			.161,
			.749,
			{ ic: .072 }
		],
		11494: [
			.723,
			.161,
			.749,
			{ ic: .072 }
		],
		11495: [
			.833,
			.161,
			1.099
		],
		11496: [
			.708,
			.161,
			.691,
			{ ic: .062 }
		],
		11497: [
			.723,
			.146,
			.736,
			{ ic: .057 }
		],
		11498: [
			.453,
			.006,
			1.074,
			{ ic: .003 }
		],
		11499: [
			.689,
			-.054,
			.951,
			{ ic: .029 }
		],
		11500: [
			.474,
			-.046,
			.653,
			{ ic: .023 }
		],
		11501: [
			.688,
			.012,
			.741
		],
		11502: [
			.439,
			.01,
			.598
		],
		11503: [
			.698,
			-.498,
			.533
		],
		11504: [
			.782,
			-.614,
			0,
			{ dx: .287 }
		],
		11505: [
			.782,
			-.614,
			0,
			{ dx: .223 }
		],
		11506: [
			.76,
			.022,
			.804
		],
		11507: [
			.503,
			.014,
			.52
		],
		11513: [
			.57,
			0,
			.893
		],
		11514: [
			.57,
			.009,
			.573,
			{ ic: .025 }
		],
		11515: [
			.57,
			.009,
			.573
		],
		11516: [
			.57,
			0,
			.893,
			{ ic: .024 }
		],
		11517: [
			.444,
			.009,
			.241,
			{ ic: .03 }
		],
		11518: [
			.419,
			.025,
			.363
		],
		11519: [
			.582,
			-.355,
			.313
		]
	} }
}, "NCM"), {}, [
	"MJX-NCM-GK",
	"MJX-NCM-GKB",
	"MJX-NCM-GKI",
	"MJX-NCM-GKBI"
]);
//#endregion
